/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, exhaustMap, catchError, withLatestFrom, switchMap } from 'rxjs/operators';
import { ProjectsService } from '../../services/projects/projects.service';
import { from, of } from 'rxjs';
import * as sharedAction from '../shared/shared.actions';
import * as ProjectsActions from './projects.actions';
import * as dashboardAction from '../dashboard/dashboard.actions';
import { ProjectsFacade } from './projects.facade';
import {
  CustomModalService,
  DELETE_RECORD_LABEL,
  PackagingLevelDetail,
  PackagingLevelDetailScenario,
  StorageTypeEnum,
} from '@piqet-angular/shared';
import { select, Store } from '@ngrx/store';
import * as ProjectsSelectors from './projects.selectors';
import { customDecode, decrypt } from '../../../../../shared/src/lib/service/helper.service';
import { ProjectsDataGridService } from 'libs/features/src/lib/layout/projects/projects-data-grid.service';
import { ProjectScenarioDataGridService } from 'libs/features/src/lib/layout/projects/project-details/project-scenario-list/project-scenario-list-data-grid.service';
import { ProjectPackMaterialListDataGridService } from 'libs/features/src/lib/layout/projects/project-details/project-material-list/project-material-list-data-grid.service';
import { cloneDeep } from 'lodash';
import { SharedFacade } from '../shared/shared.facade';
import { ProjectPackConversionDataGridService } from 'libs/features/src/lib/layout/projects/project-details/project-pack-conversion/project-pack-conversion-data-grid.service';
import { SharedService } from '../../services/shared/shared.service';
import { ProjectScenarioRetailDataGridService } from 'libs/features/src/lib/layout/projects/project-details/project-scenario-retail/project-scenario-retail-data-grid.service';
import { ProjectScenarioFillingDataGridService } from 'libs/features/src/lib/layout/projects/project-details/project-scenario-fill-data/project-scenario-filling-data-grid.service';
import { ProjectScenarioConsumerDataGridService } from 'libs/features/src/lib/layout/projects/project-details/project-scenario-consumer/project-scenario-consumer-data-grid.service';
import { ProjectScenarioWholesaleDataGridService } from 'libs/features/src/lib/layout/projects/project-details/project-scenario-wholesale-data/project-scenario-wholesale-data-grid.service';
import { ProductIngredientDataGridService } from 'libs/features/src/lib/layout/projects/product-details/product-ingredients/product-ingredient-data-grid.service';
import { ProductManufactureDataGridService } from 'libs/features/src/lib/layout/projects/product-details/product-manufacture/product-manufacturing-data-grid.service';
import { ProjectPackEOLDataGridService } from 'libs/features/src/lib/layout/projects/project-details/project-scenario-eol/project-scenario-eol-data-grid.service';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { MapsAPILoader } from '@agm/core';
import { ToastrService } from 'ngx-toastr';
import { messageConstant } from '../../../../../shared/src/lib/messageConstant';
import { ImportDataService } from 'libs/features/src/lib/layout/my-organization/import-project-components/import-data.service';
import { MyOrganizationService } from '../../services/my-organization/my-organization.service';

export function findDuplicates(arr: any) {
  const idSet = new Set();
  for (const obj of arr) {
    const id = obj.ingredientItemId || obj.productId;
    if (idSet.has(id)) {
      return true;
    }
    idSet.add(id);
  }
}
@Injectable()
export class ProjectsEffects {
  private actions$ = inject(Actions);
  StorageTypeEnum = StorageTypeEnum;
  eolData: any;
  url: any; // For project ID
  projectId: any; // For project ID
  scenarioId: any;
  packageScenarioId: any;

  // effect for get all my product ingredient  list
  getProductIngredientList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.getProductIngredientList),
      exhaustMap(action => {
        return this.projectService
          .getProjectProductIngredient(
            action.productId,
            action.myProductIngredientListPaylaod.myProductIngredientListPaylaod ||
              action.myProductIngredientListPaylaod
          )
          .pipe(
            map((data: any) => {
              data?.data?.map((x: any) => {
                x.ingredientTransportDetail.map((data: any) => {
                  data['cityName'] = data.originName;
                });
                x['transportationIds'] = x.ingredientTransportDetail.map(
                  (item: any) => item.transportationId
                );
                x['transportIcons'] = x?.ingredientTransportDetail.length
                  ? x?.ingredientTransportDetail.map((ele: any, index: any, arr: any) => {
                      return arr[index];
                    })
                  : x?.hasOwnProperty('locationTransportationItems') &&
                    x?.locationTransportationItems.length
                  ? x?.locationTransportationItems.map((ele: any, index: any, arr: any) => {
                      return arr[index];
                    })
                  : x?.hasOwnProperty('distanceTransportationItems') &&
                    x?.distanceTransportationItems.length
                  ? x?.distanceTransportationItems.map((ele: any, index: any, arr: any) => {
                      return arr[index];
                    })
                  : [];
              });

              return ProjectsActions.getProductIngredientListSuccess({
                productIngredientList: data?.data,
              });
            }),
            catchError((error: any) => of(ProjectsActions.getProductIngredientListFailure(error)))
          );
      })
    )
  );

  getProductIngredientListSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.getProductIngredientListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );
  // effect for get all my product manufacture  list
  getProductManufactureList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.getProductManufactureList),
      exhaustMap(action => {
        return this.projectService.getProjectProductManufacture(action.productId).pipe(
          map((data: any) => {
            return ProjectsActions.getProductManufactureListSuccess({
              productManufactureList: data.data,
            });
          }),
          catchError((error: any) => of(ProjectsActions.getProductManufactureListFailure(error)))
        );
      })
    )
  );

  getProductManufactureListSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.getProductManufactureListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );

  addEditMyProjectSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addEditMyProjectSuccess),
      exhaustMap(action => {
        const toaster = action.myProjectData.messageType
          ? sharedAction.ToasterError({ description: action.myProjectData.message })
          : sharedAction.ToasterSuccess({ description: action.myProjectData.message });
        action.myProjectData.notModal ? false : this.modal.close();
        this.router.navigate(['projects/projects-setting', action.myProjectData.data, 'setting']);
        return of(
          ProjectsActions.getAllMyProjectList({ myProjectListPaylaod: '' }),
          toaster,
          sharedAction.clearSearchFilter({ isClearSearch: true })
        );
      })
    )
  );

  // delete my poject list open sweet alert
  deleteMyProjectAction$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ProjectsActions.deleteDataMyProject),
        exhaustMap((action: any) => {
          return this.alertConfirmation(action);
        })
      ),
    { dispatch: false }
  );

  newMyProjectAction$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.newMyProjectAction),
      withLatestFrom(this.store.pipe(select(ProjectsSelectors.GetDefalutMaterialProjectList))),
      exhaustMap(action => {
        let errorMessage: any;
        if (action[0].ingredientIndex == 'amount' && !action[0].newMaterialData) {
          errorMessage =
            'Please fill all the mandatory information to proceed further in the process.';
        }
        if (
          action[1].length == 1 &&
          action[0].ingredientIndex == 'amount' &&
          action[0].newMaterialData
        ) {
          errorMessage = '';
        }
        let defaultMaterialList = Object.assign([], action[1]);
        if (action[0].action === 'add') {
          if (action[0].newMaterialData) {
            defaultMaterialList.push({
              ...action[0].newMaterialData,
              index: defaultMaterialList.length + 1,
            });
            errorMessage =
              'Please fill all the mandatory information to proceed further in the process.';
          }
        }
        if (action[0].action === 'edit') {
          if (defaultMaterialList.length == 1) {
            defaultMaterialList[0] = action[0].newMaterialData[0] || action[0].newMaterialData;
          } else {
            defaultMaterialList.forEach((ele: any, index: any) => {
              let newMaterialData = [];
              if (
                action[0].newMaterialData.hasOwnProperty('length') &&
                action[0].newMaterialData.length > 1
              ) {
                newMaterialData = action[0].newMaterialData;
              } else {
                newMaterialData.push(action[0].newMaterialData);
              }
              const updatedRecord = newMaterialData.find((el: any) => el.index == ele.index);
              if (updatedRecord) {
                defaultMaterialList[index] = updatedRecord;
              }
            });
          }
        }
        if (action[0].action === 'delete') {
          const deletedIngredient = action[0].newMaterialData;
          const deletedItem = defaultMaterialList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          defaultMaterialList.splice(defaultMaterialList.indexOf(deletedItem[0]), 1);
          errorMessage = '';
          defaultMaterialList = this.deleteCustomProcess(defaultMaterialList);
        }
        this.projectFacde.clearDefaultMaterial();
        return of(
          ProjectsActions.newMyProjectActionSuccess({
            newDefalutMaterialList: defaultMaterialList,
            errorMessage: errorMessage,
          })
        );
      })
    )
  );

  // effect for get all my project scenario consumer list
  getAllMyProjectScenarioConsumerList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.getAllMyProjectScenarioConsumerList),
      exhaustMap(action => {
        return this.projectService
          .getMyAllProjectScenarioConsumerList(
            action.storagetypeId,
            action.scenarioId,
            action.projectId
          )
          .pipe(
            map((data: any) => {
              return ProjectsActions.getAllMyProjectScenarioConsumerListSuccess({
                myAllProjectsScenarioConsumerList: data.data,
              });
            }),
            catchError((error: any) =>
              of(ProjectsActions.getAllMyProjectScenarioConsumerListFailure(error))
            )
          );
      })
    )
  );

  getAllMyProjectScenarioConsumerListSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.getAllMyProjectScenarioConsumerListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );
  // effect for get all my project scenario retail list
  getAllMyProjectScenarioRetailList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.getAllMyProjectScenarioRetailList),
      exhaustMap(action => {
        return this.projectService
          .getMyAllProjectScenarioRetailList(
            action.storagetypeId,
            action.scenarioId,
            action.projectId
          )
          .pipe(
            map((data: any) => {
              return ProjectsActions.getAllMyProjectScenarioRetailListSuccess({
                myAllProjectsScenarioReatilList: data.data,
              });
            }),
            catchError((error: any) =>
              of(ProjectsActions.getAllMyProjectScenarioRetailListFailure(error))
            )
          );
      })
    )
  );

  getAllMyProjectScenarioRetailListSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.getAllMyProjectScenarioRetailListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );
  // effect for get all my project scenario retail list
  getAllMyProjectScenarioWholesaleList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.getAllMyProjectScenarioWholesaleList),
      exhaustMap(action => {
        return this.projectService
          .getMyAllProjectScenarioWholesaleList(
            action.storagetypeId,
            action.scenarioId,
            action.projectId
          )
          .pipe(
            map((data: any) => {
              return ProjectsActions.getAllMyProjectScenarioWholesaleListSuccess({
                myAllProjectsScenarioWholesaleList: data.data,
              });
            }),
            catchError((error: any) =>
              of(ProjectsActions.getAllMyProjectScenarioWholesaleListFailure(error))
            )
          );
      })
    )
  );

  getAllMyProjectScenarioWholesaleListSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.getAllMyProjectScenarioWholesaleListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );

  //open add edit new project scenario material modal
  openNewAddProjectMaterialModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.openNewAddProjectMaterialModal),
      exhaustMap(action => {
        return this.projectService
          .getAddEditPackMaterialModal(action.scenarioId, action.id, action.isMaterial)
          .pipe(
            map((data: any) => {
              if (
                action.actionLabel == 'Review component details' ||
                action.actionLabel == 'Review material & conversion details'
              ) {
                data.data.conversionProcessItems = data.data.conversionProcessItems.map(
                  (item: any) => {
                    return {
                      ...item,
                      index: item.id,
                    };
                  }
                );
                data.data.distanceTransportationItems = data.data.distanceTransportationItems.map(
                  (item: any) => {
                    return {
                      ...item,
                      index: item.id,
                    };
                  }
                );
                data.data.locationTransportationItems = data.data.locationTransportationItems.map(
                  (item: any) => {
                    item.distance = this.setUnit(item);
                    return {
                      ...item,
                      index: item.id,
                      distance: item.isOrigin ? '' : item.distance,
                    };
                  }
                );
              }
              this.modal.invoke('newAddProjectMaterial', {
                initialState: {
                  newMyProjectsPackMaterial: data.data,
                  label: action.actionLabel,
                  customTransportColumnDef:
                    this.projectPackMaterialDataGridService.getCustomTransportItemsList(),
                },
                class: 'modal-xl',
              });
              this.modal.ref?.content.saveNewMyProjectPackMaterialEvent.subscribe(
                (saveNewMyProjectPackMaterialEvent: any) => {
                  return of(
                    this.projectFacde.addEditMyProjectPackMaterial(
                      saveNewMyProjectPackMaterialEvent,
                      action.pathName,
                      action.scenarioId
                    )
                  );
                }
              );
              return ProjectsActions.openNewAddProjectMaterialModalSuccess({
                openNewAddProjectMaterialModalData: data,
              });
            })
          );
      })
    )
  );

  setUnit(item: any) {
    if (!item.isOrigin) {
      return item.distance + ' ' + item.unit;
    } else {
      return item.distance;
    }
  }

  //open add edit new project scenario ingredint modal
  openModalProductIngredientModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.openModalProductIngredientModal),
      exhaustMap(action => {
        return this.projectService.openModalProductIngredient(action.productId, action.id).pipe(
          map((data: any) => {
            data.data.fillingProcessItems = data.data.fillingProcessItems.map((x: any) => {
              return { ...x, index: x.id };
            });
            data.data.productIngredientItems = data.data.productIngredientItems.map((x: any) => {
              return { ...x, index: x.ingredientId };
            });
            data.data.productData = data.data.productData.map((x: any) => {
              return { ...x, index: x.transportaionIngredientId };
            });
            data?.data?.productData.map((x: any) => {
              x.distanceTransportationItems = x?.distanceTransportationItems?.map((y: any) => {
                return {
                  ...y,
                  transportModeId: y.ingredientTransportId,
                };
              });
              x.locationTransportationItems = x.locationTransportationItems?.map((data: any) => {
                return {
                  ...data,
                  cityName: data.originName,
                };
              });
              let iconName = [];
              iconName.push(
                x?.locationTransportationItems?.map((ele: any, index: any, arr: any) => {
                  return arr[index];
                }),
                x?.distanceTransportationItems?.map((ele: any, index: any, arr: any) => {
                  return arr[index];
                }),
                x?.customeLocationTransportationItems?.map((ele: any, index: any, arr: any) => {
                  return arr[index];
                })
              );
              const allIcon = [].concat(...iconName);

              x['transportIcons'] = allIcon.sort(
                (x: any, y: any) => x?.parentOrder - y?.parentOrder
              );
              const transportIds = allIcon.map((id: any) => id.transportationId);
              x['transportationIds'] = transportIds;
            });
            data.data.productData = data.data.productData.map((x: any) => {
              return {
                ...x,
                distance:
                  x.transportIcons
                    .map((item: any) => item.distance || 0)
                    .reduce((acc: any, distance: any) => acc + distance, 0) +
                  ' ' +
                  'km',
              };
            });
            this.modal.invoke('newProjectIngredient', {
              initialState: {
                newProductIngredient: data.data,
                label: action.actionLabel,
                ingredientColumnDef:
                  this.productIngredientDataGridService.newProductIngredientColumns(),
                ingredientTransportColumnDef:
                  this.productIngredientDataGridService.newProductIngredientTransportColumns(),
                addTransportScenarioColDef:
                  this.productIngredientDataGridService.getTransportModalForManualLocationDataColumn(),
                distanceProcessColumnDef:
                  this.productIngredientDataGridService.getTransportModalForManualDestinationDataColumn(),
                customTransportColumnDef:
                  this.projectPackMaterialDataGridService.getCustomTransportItemsList(),
              },
              class: 'modal-xl',
            });
            this.modal.ref?.content.saveNewProductIngredientEvent.subscribe(
              (saveNewProductIngredientEvent: any) => {
                return of(
                  this.projectFacde.addEditProductIngredient(
                    saveNewProductIngredientEvent,
                    action.pathName,
                    action.productId
                  )
                );
              }
            );
            return ProjectsActions.openModalProductIngredientModalSuccess({
              openModalProductIngredientModalData: data,
            });
          })
        );
      })
    )
  );

  //open add edit new project scenario manufacture modal
  openNewAddProjectManufactureModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.openNewAddProjectManufactureModal),
      exhaustMap(action => {
        return this.projectService
          .getMyAllProjectScenarioModalData(
            action.projectId,
            action.scenarioTypeId,
            action.scenarioId
          )
          .pipe(
            map((data: any) => {
              this.modal.invoke('newAddProjectManufacture', {
                initialState: {
                  newMyProjects: data.data,
                  label: action.actionLabel,
                },
                class: 'modal-xl',
              });
              this.modal.ref?.content.saveNewMyProjectScenarioEvent.subscribe(
                (saveNewMyProjectScenarioEvent: any) => {
                  return of(this.projectFacde.addEditMyProject(saveNewMyProjectScenarioEvent));
                }
              );
              return ProjectsActions.openAllMyProjectScenarioModalSuccess({
                openAllMyProjectScenarioModalData: data,
              });
            })
          );
      })
    )
  );

  //open add edit new project scenario fill data modal
  openNewAddProjectFillDataModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.openNewAddProjectFillDataModal),
      exhaustMap(action => {
        return this.projectService
          .getProjectFillingAddUpdateData(action.scenarioId, action.id)
          .pipe(
            map((data: any) => {
              if (action.actionLabel == 'Review filling') {
                data.data.fillingTempDatalistIteams = data.data.fillingTempDatalistIteams.map(
                  (item: any) => {
                    return {
                      ...item,
                      index: item.id,
                    };
                  }
                );
                data.data.fillingTempDatalistIteams.map((item: any) => {
                  item.fillingTransportDetail = item.fillingTransportDetail?.map((data: any) => {
                    return {
                      ...data,
                      cityName: data.originName,
                      originId: data.cityId,
                    };
                  });
                });
                data.data.productTransportationItems = data.data.productTransportationItems.map(
                  (item: any) => {
                    return {
                      ...item,
                      index: item.id,
                    };
                  }
                );
                data.data.productLocationTransportationItems =
                  data.data?.productLocationTransportationItems.map((item: any, i: any) => {
                    return {
                      ...item,
                      index: i,
                      distance: item.isOrigin ? '' : item.distance,
                    };
                  });
                data.data.productTransportationItems.map((item: any) => {
                  item.productTransportItems = item.productTransportItems?.map((data: any) => {
                    return {
                      ...data,
                      cityName: data.originName,
                    };
                  });
                });
                // For filling process list
                data.data.fillingProcessItems = data.data?.fillingProcessItems.map(
                  (item: any, i: any) => {
                    return {
                      ...item,
                      index: i,
                    };
                  }
                );
              }
              this.modal.invoke('newAddProjectFillData', {
                initialState: {
                  fillingData: data.data,
                  label: action.actionLabel,
                  scenarioId: action.scenarioId,
                  projectId: action.projectId,
                },
                class: 'modal-xl',
              });
              this.modal.ref?.content.saveNewMyProjectFillingEvent.subscribe(
                (saveNewMyProjectFillingEvent: any) => {
                  return of(this.projectFacde.addEditProjectFilling(saveNewMyProjectFillingEvent));
                }
              );
              return ProjectsActions.openNewAddProjectFillDataSuccess({
                addEditFillingModalData: data,
              });
            })
          );
      })
    )
  );

  deleteOrganizationEffect$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ProjectsActions.openProjectDeleteModal),
        exhaustMap((action: any) => {
          return this.alertConfirmation(action);
        })
      ),
    { dispatch: false }
  );

  //sweet alert pop-up

  deleteProjectData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.deleteProjectData),
      exhaustMap(action => {
        switch (action.pathName) {
          case 'material-list':
            return this.projectService.deleteProjectPackMaterialList(action.projectId).pipe(
              map((data: any) => {
                data['pathName'] = action.pathName;
                data['scenarioId'] = action.id;
                return ProjectsActions.deleteProjectDataSuccess({
                  deleteMessage: data,
                });
              })
            );
            break;
          case 'conversion-list':
            return this.projectService.deleteProjectPackMaterialList(action.projectId).pipe(
              map((data: any) => {
                data['pathName'] = action.pathName;
                data['scenarioId'] = action.id;
                return ProjectsActions.deleteProjectDataSuccess({
                  deleteMessage: data,
                });
              })
            );
            break;
          case 'retail-list':
            return this.projectService.deleteProjectPackRetailList(action.projectId).pipe(
              map((data: any) => {
                data['pathName'] = action.pathName;
                data['scenarioId'] = action.id;
                return ProjectsActions.deleteProjectDataSuccess({
                  deleteMessage: data,
                });
              })
            );
            break;
          case 'wholesale-data-list':
            return this.projectService.deleteProjectWholesale(action.id).pipe(
              map((data: any) => {
                data['pathName'] = action.pathName;
                data['scenarioId'] = action.projectId;
                return ProjectsActions.deleteProjectDataSuccess({
                  deleteMessage: data,
                });
              })
            );
            break;
          default:
            return of();
            break;
        }
      })
    )
  );

  deleteProjectDataSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.deleteProjectDataSuccess),
      exhaustMap((action: any) => {
        let toaster: any = action.deleteMessage.messageType
          ? sharedAction.ToasterError({
              description: action.deleteMessage.message,
            })
          : sharedAction.ToasterSuccess({
              description: action.deleteMessage.message,
            });
        switch (action.deleteMessage.pathName) {
          case 'preRetail':
            this.getPreRetailData();
            return of(toaster, sharedAction.clearSearchFilter({ isClearSearch: true }));
            break;
          case 'postRetail':
            this.getPostRetailData();
            return of(toaster, sharedAction.clearSearchFilter({ isClearSearch: true }));
            break;
          case 'admin-projects':
          case '':
            // eslint-disable-next-line no-case-declarations
            if (action.deleteMessage.pageName == 'productProject') {
              this.sharedFacade.clearSearch(true);
              return of(
                ProjectsActions.getAllMyProductProjectList({ myProductProjectListPaylaod: '' }),
                toaster,
                sharedAction.clearSearchFilter({ isClearSearch: true })
              );
            } else {
              return of(
                ProjectsActions.getAllMyProjectList({ myProjectListPaylaod: '' }),
                toaster,
                sharedAction.clearSearchFilter({ isClearSearch: true })
              );
            }
            break;
          case 'material-list':
            // eslint-disable-next-line no-case-declarations
            const packMaterial = {
              myProjectPackMaterailListPaylaod:
                this.projectPackMaterialDataGridService.getPackMaterialProjectPayload(''),
            };
            this.projectFacde.clearDefaultMaterial();
            return of(
              ProjectsActions.getAllMyProjectPackMaterialList({
                myProjectListPackMaterialPaylaod: packMaterial,
                scenarioId: action.deleteMessage.scenarioId,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'conversion-list':
            // eslint-disable-next-line no-case-declarations
            const packConversion = {
              myProjectPackConversionListPaylaod:
                this.projectPackConversionDataGridService.getPackConversionProjectPayload(''),
            };
            this.projectFacde.clearDefaultMaterial();
            return of(
              ProjectsActions.getAllMyProjectPackConversionList({
                myProjectListPackConversionPaylaod: packConversion,
                scenarioId: action.deleteMessage.scenarioId,
                projectId: this.projectId,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'wholesale-data-list':
            const wholesale = this.projectScenarioWholesaleDataGridService.getPayload('');
            return of(
              ProjectsActions.getAllMyProjectScenarioWholesaleList({
                myProjectScenarioWholesaleListPaylaod: wholesale,
                storagetypeId: 1,
                scenarioId: action.deleteMessage.scenarioId,
                projectId: this.projectId,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          default:
            return of(dashboardAction.clearUserDashboardData(), dashboardAction.getDashboardData());
            break;
        }
      })
    )
  );

  saveCopiedScenario$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.copyScenario),
      exhaustMap(action => {
        return this.projectService.saveCopiedProjectScenario(action.copyScenarioPayload).pipe(
          map((data: any) => {
            return ProjectsActions.copyScenarioSuccess({
              copyScenarioData: data,
            });
          }),
          catchError((error: any) => of(ProjectsActions.copyScenarioFailure(error)))
        );
      })
    )
  );

  saveCopiedScenarioSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.copyScenarioSuccess),
      exhaustMap(action => {
        if (action.copyScenarioData.messageType != 0) {
          return of(
            sharedAction.ToasterError({
              description: action.copyScenarioData.message,
            })
          );
        } else {
          this.modal.close();
          this.recallSideBar();
          const scenarioPayload = this.projectScenarioDataGridService.getPayload('');
          this.projectId = Number(
            atob(decodeURIComponent(customDecode(location.href.split('/')?.[6])))
          );
          return of(
            sharedAction.ToasterSuccess({
              description: action.copyScenarioData.message,
            }),
            sharedAction.clearSearchFilter({ isClearSearch: true }),
            ProjectsActions.getAllMyProjectScenarioList({
              myProjectListPaylaod: scenarioPayload,
              projectId: this.projectId,
              scenarioTypeId: 1,
            })
          );
        }
      })
    )
  );

  getAllMyProjectPackConversionListSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.getAllMyProjectPackConversionListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );

  addTransportScenarioForPackMaterial$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addTransportScenarioForPackMaterial),
      withLatestFrom(
        this.store.pipe(select(ProjectsSelectors.GetTransportScenarioListForPackMaterial))
      ),
      exhaustMap(action => {
        let error = '';
        let distanceError = '';
        let transportScenarioList = Object.assign([], action[1]);
        if (action[0].action == 'reset') {
          transportScenarioList = this.addEnableEditing(transportScenarioList);
        }
        if (action[0].action === 'add' && transportScenarioList.length == 0) {
          if (action[0].transport) {
            transportScenarioList.push({
              ...action[0].transport,
              index: transportScenarioList.length + 1,
              isOrigin: false,
              alwaysOrigin: true,
            });
          }
        } else if (transportScenarioList.length > 0 && action[0].action === 'add') {
          if (action[0].transport) {
            if (
              transportScenarioList.find(
                (x: any) => x.hasOwnProperty('cityId') && x.cityId == action[0].transport.cityId
              )
            ) {
              error = 'Record is already exist.';
            } else {
              transportScenarioList = cloneDeep(transportScenarioList);
              if (transportScenarioList.find((x: any) => !x.isOrigin && x.alwaysOrigin)) {
                transportScenarioList.find((x: any) => !x.isOrigin && x.alwaysOrigin).isOrigin =
                  true;
              }
              transportScenarioList.push({
                ...action[0].transport,
                index: transportScenarioList.length + 1,
                isOrigin: false,
              });
            }
          }
        }
        if (action[0].action === 'edit') {
          transportScenarioList = this.addEnableEditing(transportScenarioList);
          transportScenarioList.forEach((element: any, index: any) => {
            if (transportScenarioList.length == 1) {
              transportScenarioList[index] = action[0].transport;
            } else {
              const editedIngredient = action[0].transport;
              const updatedItem = transportScenarioList.filter(
                (data: any) => data.index == action[0].transport.index
              );
              const index = transportScenarioList.indexOf(updatedItem[0]);
              transportScenarioList[index] = editedIngredient;
            }
          });
        }
        if (action[0].action === 'delete') {
          const deletedIngredient = action[0].transport;
          const deletedItem = transportScenarioList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          transportScenarioList.splice(transportScenarioList.indexOf(deletedItem[0]), 1);
          transportScenarioList = cloneDeep(transportScenarioList);
          if (transportScenarioList.length == 1) {
            transportScenarioList.find((x: any) => (x.isOrigin = false));
          }
          transportScenarioList = this.deleteCustomProcess(transportScenarioList);
        }
        if (transportScenarioList.length > 1 && action[0]?.action != 'edit') {
          transportScenarioList[0]['isOrigin'] = true;
          transportScenarioList[0]['alwaysOrigin'] = true;
        }
        transportScenarioList.map((element: any, index: any) => {
          if ((element.distance == '0' || element.distance == '0 km') && index != 0) {
            distanceError = messageConstant.noRecommendedConversionMessage;
          }
        });
        return of(
          ProjectsActions.addTransportScenarioForPackMaterialSuccess({
            transportScenarioList: transportScenarioList,
            error: error,
            distanceError: distanceError,
          })
        );
      })
    )
  );

  addTransportScenarioForDistancePackMaterial$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addTransportScenarioForDistancePackMaterial),
      withLatestFrom(
        this.store.pipe(select(ProjectsSelectors.GetTransportScenarioListFordistance))
      ),
      exhaustMap(action => {
        let error = '';
        let transportScenarioList = Object.assign([], action[1]);
        if (action[0].action == 'reset') {
          transportScenarioList = this.addEnableEditing(transportScenarioList);
        }
        if (action[0].action === 'add' && transportScenarioList.length == 0) {
          if (action[0].transport) {
            transportScenarioList.push({
              ...action[0].transport,
              index: transportScenarioList.length + 1,
            });
          }
        } else if (transportScenarioList.length > 0 && action[0].action === 'add') {
          if (action[0].transport) {
            if (
              transportScenarioList.find(
                (x: any) => x.hasOwnProperty('cityId') && x.cityId == action[0].transport.cityId
              )
            ) {
              error = 'Record is already exist.';
            } else {
              transportScenarioList = cloneDeep(transportScenarioList);
              if (transportScenarioList.find((x: any) => !x.isOrigin && x.alwaysOrigin)) {
                transportScenarioList.find((x: any) => !x.isOrigin && x.alwaysOrigin).isOrigin =
                  true;
              }
              transportScenarioList.push({
                ...action[0].transport,
                index: transportScenarioList.length + 1,
                isOrigin: false,
              });
            }
          }
        }
        if (action[0].action === 'edit') {
          transportScenarioList = this.addEnableEditing(transportScenarioList);
          transportScenarioList.forEach((element: any, index: any) => {
            if (transportScenarioList.length == 1) {
              transportScenarioList[index] = action[0].transport;
            } else {
              const editedIngredient = action[0].transport;
              const updatedItem = transportScenarioList.filter(
                (data: any) => data.index == action[0].transport.index
              );
              const index = transportScenarioList.indexOf(updatedItem[0]);
              transportScenarioList[index] = editedIngredient;
            }
          });
        }
        if (action[0].action === 'delete') {
          const deletedIngredient = action[0].transport;
          const deletedItem = transportScenarioList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          transportScenarioList.splice(transportScenarioList.indexOf(deletedItem[0]), 1);
        }
        return of(
          ProjectsActions.addTransportScenarioForDistancePackMaterialSuccess({
            transportScenarioListForDistance: transportScenarioList,
            error: error,
          })
        );
      })
    )
  );
  addPackMaterialConversion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addPackMaterialConversion),
      withLatestFrom(this.store.pipe(select(ProjectsSelectors.GetProjectPackConversionList))),
      exhaustMap(action => {
        let error = '';
        let transportScenarioList = Object.assign([], action[1]);
        if (action[0].action === 'add' && transportScenarioList.length == 0) {
          if (action[0].transport) {
            transportScenarioList.push({
              ...action[0].transport,
              index: transportScenarioList.length + 1,
            });
          }
        } else if (transportScenarioList.length > 0 && action[0].action === 'add') {
          if (action[0].transport) {
            if (
              transportScenarioList.find(
                (x: any) => x.hasOwnProperty('cityId') && x.cityId == action[0].transport.cityId
              )
            ) {
              error = 'Record is already exist.';
            } else {
              transportScenarioList = cloneDeep(transportScenarioList);
              if (transportScenarioList.find((x: any) => !x.isOrigin && x.alwaysOrigin)) {
                transportScenarioList.find((x: any) => !x.isOrigin && x.alwaysOrigin).isOrigin =
                  true;
              }
              transportScenarioList.push({
                ...action[0].transport,
                index: transportScenarioList.length + 1,
                isOrigin: false,
              });
            }
          }
        }
        if (action[0].action === 'edit') {
          transportScenarioList.forEach((element: any, index: any) => {
            if (transportScenarioList.length == 1) {
              transportScenarioList[index] = action[0].transport;
            } else {
              const editedIngredient = action[0].transport;
              const updatedItem = transportScenarioList.filter(
                (data: any) => data.index == action[0].transport.index
              );
              const index = transportScenarioList.indexOf(updatedItem[0]);
              transportScenarioList[index] = editedIngredient;
            }
          });
        }
        if (action[0].action === 'delete') {
          const deletedIngredient = action[0].transport;
          const deletedItem = transportScenarioList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          transportScenarioList.splice(transportScenarioList.indexOf(deletedItem[0]), 1);
        }
        return of(
          ProjectsActions.addPackMaterialConversionSuccess({
            conversionList: transportScenarioList,
            error: error,
          })
        );
      })
    )
  );
  addEditMyProjectPackMaterial$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addEditMyProjectPackMaterial),
      exhaustMap(action => {
        return this.projectService
          .addEditMyAllProjectPackMaterialData(action.myProjectDataPayload)
          .pipe(
            map((data: any) => {
              data['pathName'] = action.pathName;
              data['scenarioId'] = action.scenarioId;
              return ProjectsActions.addEditMyProjectPackMaterialSuccess({
                myProjectPackMaterialData: data,
              });
            }),
            catchError((error: any) =>
              of(ProjectsActions.addEditMyProjectPackMaterialFailure(error))
            )
          );
      })
    )
  );

  addEditMyProjectPackMaterialSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addEditMyProjectPackMaterialSuccess),
      exhaustMap(action => {
        const toaster = action.myProjectPackMaterialData.messageType
          ? sharedAction.ToasterError({ description: action.myProjectPackMaterialData.message })
          : sharedAction.ToasterSuccess({ description: action.myProjectPackMaterialData.message });
        this.modal.close();
        this.projectFacde.clearDefaultMaterial();
        switch (action.myProjectPackMaterialData.pathName) {
          case 'material-list':
            // eslint-disable-next-line no-case-declarations
            this.getProjectMaterialList();
            return of(toaster, sharedAction.clearSearchFilter({ isClearSearch: true }));
            break;
          case 'conversion-list':
            // eslint-disable-next-line no-case-declarations
            this.getProjectConversionList();
            return of(toaster, sharedAction.clearSearchFilter({ isClearSearch: true }));
            break;
          default:
            return of(dashboardAction.clearUserDashboardData(), dashboardAction.getDashboardData());
            break;
        }
      })
    )
  );

  addEditProductIngredient$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addEditProductIngredient),
      exhaustMap(action => {
        return this.projectService
          .addEditMyAllProjectProductIngredient(action.myProductIngredientDataPayload)
          .pipe(
            map((data: any) => {
              data['pathName'] = action.pathName;
              data['productId'] = action.productId;
              return ProjectsActions.addEditProductIngredientSuccess({
                myProjectProductIngredientData: data,
              });
            }),
            catchError((error: any) => of(ProjectsActions.addEditProductIngredientFailure(error)))
          );
      })
    )
  );

  addEditProductIngredientSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addEditProductIngredientSuccess),
      exhaustMap(action => {
        const toaster = action.myProjectProductIngredientData.messageType
          ? sharedAction.ToasterError({
              description: action.myProjectProductIngredientData.message,
            })
          : sharedAction.ToasterSuccess({
              description: action.myProjectProductIngredientData.message,
            });
        this.modal.close();
        this.projectFacde.clearDefaultMaterial();
        switch (action.myProjectProductIngredientData.pathName) {
          case 'product-ingredient':
            // eslint-disable-next-line no-case-declarations
            const packMaterial = {
              myProductIngredientListPaylaod: this.productIngredientDataGridService.getPayload(''),
            };
            return of(
              ProjectsActions.getProductIngredientList({
                myProductIngredientListPaylaod: packMaterial,
                productId: action.myProjectProductIngredientData.productId,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'product-manufacture':
            // eslint-disable-next-line no-case-declarations
            const packManufacture = {
              myProductManufactureListPaylaod:
                this.productManufactureDataGridService.getPayload(''),
            };
            return of(
              ProjectsActions.getProductManufactureList({
                myProductManufactureListPaylaod: packManufacture,
                productId: action.myProjectProductIngredientData.productId,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          default:
            return of(dashboardAction.clearUserDashboardData(), dashboardAction.getDashboardData());
            break;
        }
      })
    )
  );

  //Effects for projectPackMaterialCopySave.
  projectPackMaterialCopySave$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.projectPackMaterialCopySave),
      exhaustMap(action => {
        return this.projectService.copyProjectPackMaterial(action.scenarioId, action.payload).pipe(
          map((data: any) => {
            data['pathName'] = action.pathName;
            data['scenarioId'] = action.scenarioId;
            return ProjectsActions.projectPackMaterialCopySaveSuccess({
              copyProjectPackMaterialDataMessage: data,
            });
          }),
          catchError((error: any) => of(ProjectsActions.projectPackMaterialCopySaveFailure(error)))
        );
      })
    )
  );

  projectPackMaterialCopySaveSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.projectPackMaterialCopySaveSuccess),
      exhaustMap(action => {
        const toaster = action.copyProjectPackMaterialDataMessage.messageType
          ? sharedAction.ToasterError({
              description: action.copyProjectPackMaterialDataMessage.message,
            })
          : sharedAction.ToasterSuccess({
              description: action.copyProjectPackMaterialDataMessage.message,
            });
        this.modal.close();
        this.projectFacde.clearDefaultMaterial();
        switch (action.copyProjectPackMaterialDataMessage.pathName) {
          case 'material-list':
            // eslint-disable-next-line no-case-declarations
            const packMaterial = {
              myProjectPackMaterailListPaylaod:
                this.projectPackMaterialDataGridService.getPackMaterialProjectPayload(''),
            };
            return of(
              ProjectsActions.getAllMyProjectPackMaterialList({
                myProjectListPackMaterialPaylaod: packMaterial,
                scenarioId: action.copyProjectPackMaterialDataMessage.scenarioId,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'conversion-list':
            // eslint-disable-next-line no-case-declarations
            const packConversion = {
              myProjectPackConversionListPaylaod:
                this.projectPackConversionDataGridService.getPackConversionProjectPayload(''),
            };
            this.projectFacde.clearDefaultMaterial();
            return of(
              ProjectsActions.getAllMyProjectPackConversionList({
                myProjectListPackConversionPaylaod: packConversion,
                scenarioId: action.copyProjectPackMaterialDataMessage.scenarioId,
                projectId: this.projectId,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          default:
            return of(dashboardAction.clearUserDashboardData(), dashboardAction.getDashboardData());
            break;
        }
      })
    )
  );

  //open add edit new project scenario reatail modal
  openNewAddProjectRetaiModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.openNewAddProjectRetaiModal),
      exhaustMap(action => {
        if (action.pathName == 'consumer-list') {
          return this.projectService
            .openAddEditModalDataForProjectScenarioConsumer(
              action.scenarioId,
              action.id,
              action.storageTypeId
            )
            .pipe(
              map((data: any) => {
                data.data.eOLListViewModels = data.data.eOLListViewModels?.map(
                  (item: any, index: any) => {
                    return {
                      ...item,
                      index: index + 1,
                    };
                  }
                );
                if (action.actionLabel == 'Review consumer') {
                  data.data.locationTransportationItems = data.data.locationTransportationItems.map(
                    (item: any, index: any) => {
                      item.distance = this.setUnit(item);
                      return {
                        ...item,
                        index: item.id,
                        distance: item.isOrigin ? '' : item.distance,
                      };
                    }
                  );
                  this.reMapDistanceData(data);
                }
                this.openPopupRetailAndConsumer(data, action);
                return ProjectsActions.openNewAddProjectRetaiModalSuccess({
                  openNewAddProjectRetailModalData: data,
                });
              })
            );
        } else {
          return this.projectService
            .getAddEditPackRetailModal(action.scenarioId, action.id, action.storageTypeId)
            .pipe(
              map((data: any) => {
                data.data.eOLListViewModels = data.data.eOLListViewModels.map(
                  (item: any, index: any) => {
                    return {
                      ...item,
                      index: index + 1,
                    };
                  }
                );
                if (action.actionLabel == 'Review retail') {
                  this.reMapDistanceData(data);
                  data.data.locationTransportationItems = data.data.locationTransportationItems.map(
                    (item: any, index: any) => {
                      item.distance = this.setUnit(item);
                      return {
                        ...item,
                        index: item.id,
                        distance: item.isOrigin ? '' : item.distance,
                      };
                    }
                  );
                }
                this.openPopupRetailAndConsumer(data, action);
                return ProjectsActions.openNewAddProjectRetaiModalSuccess({
                  openNewAddProjectRetailModalData: data,
                });
              })
            );
        }
      })
    )
  );

  //manual location transport pack retail
  addTransportScenarioForPackRetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addTransportScenarioForPackRetail),
      withLatestFrom(this.store.pipe(select(ProjectsSelectors.GetTransportScenarioListForRetail))),
      exhaustMap(action => {
        let error = '';
        let distanceError = '';
        let transportScenarioList = Object.assign([], action[1]);
        if (action[0].action == 'reset') {
          transportScenarioList = this.addEnableEditing(transportScenarioList);
        }
        if (action[0].action === 'add' && transportScenarioList.length == 0) {
          if (action[0].transport) {
            transportScenarioList.push({
              ...action[0].transport,
              index: transportScenarioList.length + 1,
              isOrigin: false,
              alwaysOrigin: true,
            });
          }
        } else if (transportScenarioList.length > 0 && action[0].action === 'add') {
          if (action[0].transport) {
            if (
              transportScenarioList.find(
                (x: any) => x.hasOwnProperty('cityId') && x.cityId == action[0].transport.cityId
              )
            ) {
              error = 'Record is already exist.';
            } else {
              transportScenarioList = cloneDeep(transportScenarioList);
              if (transportScenarioList.find((x: any) => !x.isOrigin && x.alwaysOrigin)) {
                transportScenarioList.find((x: any) => !x.isOrigin && x.alwaysOrigin).isOrigin =
                  true;
              }
              transportScenarioList.push({
                ...action[0].transport,
                index: transportScenarioList.length + 1,
                isOrigin: false,
              });
            }
          }
        }
        if (action[0].action === 'edit') {
          transportScenarioList = this.addEnableEditing(transportScenarioList);
          transportScenarioList.forEach((element: any, index: any) => {
            if (transportScenarioList.length == 1) {
              transportScenarioList[index] = action[0].transport;
            } else {
              const editedIngredient = action[0].transport;
              const updatedItem = transportScenarioList.filter(
                (data: any) => data.index == action[0].transport.index
              );
              const index = transportScenarioList.indexOf(updatedItem[0]);
              transportScenarioList[index] = editedIngredient;
            }
          });
        }
        if (action[0].action === 'delete') {
          const deletedIngredient = action[0].transport;
          const deletedItem = transportScenarioList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          transportScenarioList.splice(transportScenarioList.indexOf(deletedItem[0]), 1);
          transportScenarioList = cloneDeep(transportScenarioList);
          if (transportScenarioList.length == 1) {
            transportScenarioList.find((x: any) => (x.isOrigin = false));
          }
        }
        if (transportScenarioList.length > 1 && action[0]?.action != 'edit') {
          transportScenarioList[0]['isOrigin'] = true;
          transportScenarioList[0]['alwaysOrigin'] = true;
        }
        transportScenarioList.map((element: any, index: any) => {
          if ((element.distance == '0' || element.distance == '0 km') && index != 0) {
            distanceError = messageConstant.noRecommendedConversionMessage;
          }
        });
        return of(
          ProjectsActions.addTransportScenarioForPackRetailSuccess({
            transportScenarioManualLocationList: transportScenarioList,
            error: error,
            distanceError: distanceError,
          })
        );
      })
    )
  );

  addTransportScenarioForDistancePackRetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addTransportScenarioForDistancePackRetail),
      withLatestFrom(
        this.store.pipe(select(ProjectsSelectors.GetTransportScenarioListForDistancePackRetail))
      ),
      exhaustMap(action => {
        let error = '';
        let transportScenarioList = Object.assign([], action[1]);
        if (action[0].action == 'reset') {
          transportScenarioList = this.addEnableEditing(transportScenarioList);
        }
        if (action[0].action === 'add' && transportScenarioList.length == 0) {
          if (action[0].transport) {
            transportScenarioList.push({
              ...action[0].transport,
              index: transportScenarioList.length + 1,
            });
          }
        } else if (transportScenarioList.length > 0 && action[0].action === 'add') {
          if (action[0].transport) {
            if (
              transportScenarioList.find(
                (x: any) => x.hasOwnProperty('cityId') && x.cityId == action[0].transport.cityId
              )
            ) {
              error = 'Record is already exist.';
            } else {
              transportScenarioList = cloneDeep(transportScenarioList);
              if (transportScenarioList.find((x: any) => !x.isOrigin && x.alwaysOrigin)) {
                transportScenarioList.find((x: any) => !x.isOrigin && x.alwaysOrigin).isOrigin =
                  true;
              }
              transportScenarioList.push({
                ...action[0].transport,
                index: transportScenarioList.length + 1,
                isOrigin: false,
              });
            }
          }
        }
        if (action[0].action === 'edit') {
          transportScenarioList = this.addEnableEditing(transportScenarioList);
          transportScenarioList.forEach((element: any, index: any) => {
            if (transportScenarioList.length == 1) {
              transportScenarioList[index] = action[0].transport;
            } else {
              const editedIngredient = action[0].transport;
              const updatedItem = transportScenarioList.filter(
                (data: any) => data.index == action[0].transport.index
              );
              const index = transportScenarioList.indexOf(updatedItem[0]);
              transportScenarioList[index] = editedIngredient;
            }
          });
        }
        if (action[0].action === 'delete') {
          const deletedIngredient = action[0].transport;
          const deletedItem = transportScenarioList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          transportScenarioList.splice(transportScenarioList.indexOf(deletedItem[0]), 1);
        }
        return of(
          ProjectsActions.addTransportScenarioForDistancePackRetailSuccess({
            retailTransportScenarioListForDistance: transportScenarioList,
            error: error,
          })
        );
      })
    )
  );

  addEditMyProjectPackRetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addEditMyProjectPackRetail),
      exhaustMap(action => {
        if (action.pathName == 'consumer-list') {
          return this.projectService
            .addEditMyAllProjectPackConsumerData(action.myProjectDataPayload)
            .pipe(
              map((data: any) => {
                data['pathName'] = action.pathName;
                data['scenarioId'] = action.scenarioId;
                return ProjectsActions.addEditMyProjectPackRetailSuccess({
                  myProjectPackRetailData: data,
                });
              }),
              catchError((error: any) =>
                of(ProjectsActions.addEditMyProjectPackRetailFailure(error))
              )
            );
        } else {
          return this.projectService
            .addEditMyAllProjectPackRetailData(action.myProjectDataPayload)
            .pipe(
              map((data: any) => {
                data['pathName'] = action.pathName;
                data['scenarioId'] = action.scenarioId;
                return ProjectsActions.addEditMyProjectPackRetailSuccess({
                  myProjectPackRetailData: data,
                });
              }),
              catchError((error: any) =>
                of(ProjectsActions.addEditMyProjectPackRetailFailure(error))
              )
            );
        }
      })
    )
  );

  addEditMyProjectPackRetailSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addEditMyProjectPackRetailSuccess),
      exhaustMap(action => {
        const toaster = action.myProjectPackRetailData.messageType
          ? sharedAction.ToasterError({ description: action.myProjectPackRetailData.message })
          : sharedAction.ToasterSuccess({ description: action.myProjectPackRetailData.message });
        this.modal.close();
        this.projectFacde.clearDefaultMaterial();
        switch (action.myProjectPackRetailData.pathName) {
          case 'retail-list':
            // eslint-disable-next-line no-case-declarations
            const packRetail = {
              myProjectPackRetailListPaylaod:
                this.projectScenarioRetailDataGridService.getPayload(''),
            };
            this.getRetailListData();
            return of(toaster, sharedAction.clearSearchFilter({ isClearSearch: true }));
            break;
          case 'consumer-list':
            // eslint-disable-next-line no-case-declarations
            this.getConsumerList();
            return of(toaster, sharedAction.clearSearchFilter({ isClearSearch: true }));
            break;
          default:
            return of(dashboardAction.clearUserDashboardData(), dashboardAction.getDashboardData());
            break;
        }
      })
    )
  );

  getConsumerList() {
    this.projectScenarioConsumerDataGridService.getConsumerDataList();
  }

  addPackRetailEol$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addPackRetailEol),
      withLatestFrom(
        this.store.pipe(select(ProjectsSelectors.GetTransportScenarioEolDataListForRetail))
      ),
      exhaustMap(action => {
        let error = '';
        let transportScenarioList = Object.assign([], action[1]);
        if (action[0].action === 'edit') {
          transportScenarioList.forEach((element: any, index: any) => {
            const editedIngredient = action[0].transport;
            const objectValue = cloneDeep(action[0].transport);
            delete objectValue['index'];
            delete objectValue['materialId'];
            delete objectValue['materialName'];
            delete objectValue['isCustomMaterial'];
            const values: any = Object.values(objectValue).reduce(
              (s: any, v: any) => (s += typeof v === 'number' ? v : 0),
              0
            );
            if (values <= 100) {
              const updatedItem = transportScenarioList.filter(
                (data: any) => data.index == action[0].transport.index
              );
              const index = transportScenarioList.indexOf(updatedItem[0]);
              transportScenarioList[index] = editedIngredient;
              let eoldata = {
                error: '',
                rowValue: values,
                isShowError: true,
              };
              this.eolData = eoldata;
            } else {
              let eoldata = {
                error: `End-of-life total must be 100 % for ${editedIngredient.materialName}`,
                isShowError: false,
              };
              this.eolData = eoldata;
              return;
            }
          });
        }
        return of(
          ProjectsActions.addPackRetailEolSuccess({
            retailEolList: transportScenarioList,
            error: this.eolData,
          })
        );
      })
    )
  );

  getProjectFillingList() {
    return this.projectScenarioFillingDataGridService.getFillingDataList();
  }
  getProjectMaterialList() {
    return this.projectPackMaterialDataGridService.getPackMaterialList();
  }
  getProjectConversionList() {
    return this.projectPackConversionDataGridService.getPackConversionList();
  }

  getProjectWholesaleList() {
    return this.projectScenarioWholesaleDataGridService.getWholesaleDataList();
  }

  getPreRetailData() {
    return this.projectPackEOLDataGridService.getPreRetail();
  }

  getPostRetailData() {
    return this.projectPackEOLDataGridService.getPostRetail();
  }

  addFillingProcess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addFillingProcess),
      withLatestFrom(this.store.pipe(select(ProjectsSelectors.GetFillingProcessList))),
      exhaustMap(action => {
        let error = '';
        let fillingProcessList = Object.assign([], action[1]);
        if (action[0].action === 'add') {
          if (action[0].filling) {
            fillingProcessList.push({ ...action[0].filling, index: fillingProcessList.length + 1 });
          }
        } else if (action[0].action === 'edit') {
          const updatedFillingProcessList = fillingProcessList.map((item: any) => {
            return {
              ...item,
              countryId: action[0].filling.id,
              countryName: action[0].filling.name,
            };
          });
          fillingProcessList = updatedFillingProcessList;
        } else if (action[0].action === 'delete') {
          const deletedIngredient = action[0].filling;
          const deletedItem = fillingProcessList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          fillingProcessList.splice(fillingProcessList.indexOf(deletedItem[0]), 1);
        }
        return of(
          ProjectsActions.addFillingProcessSuccess({
            fillingList: fillingProcessList,
            error: error,
          })
        );
      })
    )
  );

  addLocationProcess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addLocationProcess),
      withLatestFrom(this.store.pipe(select(ProjectsSelectors.GetLocationList))),
      exhaustMap(action => {
        let error = '';
        let distanceError = '';
        let locationProcessList = Object.assign([], action[1]);
        if (action[0].action == 'reset') {
          locationProcessList = this.addEnableEditing(locationProcessList);
        }
        if (action[0].action === 'add' && locationProcessList.length == 0) {
          if (action[0].location) {
            locationProcessList.push({
              ...action[0].location,
              index: locationProcessList.length + 1,
              isOrigin: false,
              alwaysOrigin: true,
            });
          }
        } else if (action[0].action === 'add' && locationProcessList.length > 0) {
          locationProcessList = cloneDeep(locationProcessList);
          if (action[0].location) {
            if (locationProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin)) {
              locationProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin).isOrigin = true;
            }
            locationProcessList.push({
              ...action[0].location,
              index: locationProcessList.length + 1,
              isOrigin: false,
            });
          }
        } else if (action[0].action === 'edit') {
          locationProcessList = this.addEnableEditing(locationProcessList);
          locationProcessList.forEach((element: any, index: any) => {
            if (locationProcessList.length == 1) {
              locationProcessList[index] = action[0].location;
            } else {
              const editedIngredient = action[0].location;
              const updatedItem = locationProcessList.filter(
                (data: any) => data.index == action[0].location.index
              );
              const index = locationProcessList.indexOf(updatedItem[0]);
              locationProcessList[index] = editedIngredient;
            }
          });
        } else if (action[0].action === 'delete') {
          const deletedIngredient = action[0].location;
          const deletedItem = locationProcessList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          locationProcessList.splice(locationProcessList.indexOf(deletedItem[0]), 1);
          locationProcessList = cloneDeep(locationProcessList);
          if (locationProcessList.length == 1) {
            locationProcessList.find((x: any) => (x.isOrigin = false));
          }
          locationProcessList = this.deleteCustomProcess(locationProcessList);
        }
        if (locationProcessList.length > 1 && action[0]?.action != 'edit') {
          locationProcessList[0]['isOrigin'] = true;
          locationProcessList[0]['alwaysOrigin'] = true;
        }
        locationProcessList.map((element: any, index: any) => {
          if ((element.distance == '0' || element.distance == '0 km') && index != 0) {
            distanceError = messageConstant.noRecommendedConversionMessage;
          }
        });
        return of(
          ProjectsActions.addLocationProcessSuccess({
            locationList: locationProcessList,
            replicaLocation: locationProcessList,
            error: error,
            distanceError: distanceError,
          })
        );
      })
    )
  );

  addDistanceProcess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addDistanceTransport),
      withLatestFrom(
        this.store.pipe(select(ProjectsSelectors.GetDistanceList)),
        this.store.pipe(select(ProjectsSelectors.GetReplicaDistanceList))
      ),
      exhaustMap(action => {
        let error = '';
        let distanceProcessList = Object.assign([], action[1]);
        let replicadistance = Object.assign([], action[2]);
        if (action[0].action == 'reset') {
          distanceProcessList = this.addEnableEditing(distanceProcessList);
        }
        if (action[0].action === 'add' && distanceProcessList.length == 0) {
          if (action[0].distance) {
            distanceProcessList.push({
              ...action[0].distance,
              index: distanceProcessList.length + 1,
              isDistance: true,
            });
          }
        } else if (action[0].action === 'add' && distanceProcessList.length > 0) {
          distanceProcessList = cloneDeep(distanceProcessList);
          if (action[0].distance) {
            if (distanceProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin)) {
              distanceProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin).isOrigin = true;
            }
            distanceProcessList.push({
              ...action[0].distance,
              index: distanceProcessList.length + 1,
              isDistance: true,
            });
          }
        } else if (action[0].action === 'edit') {
          distanceProcessList = this.addEnableEditing(distanceProcessList);
          distanceProcessList.forEach((element: any, index: any) => {
            Object.freeze(action[0].distance);
            const objCopy = { ...action[0].distance };
            objCopy.isDistance = true;
            if (distanceProcessList.length == 1) {
              distanceProcessList[index] = objCopy;
            } else {
              const editedIngredient = objCopy;
              const updatedItem = distanceProcessList.filter(
                (data: any) => data.index == action[0].distance.index
              );
              const index = distanceProcessList.indexOf(updatedItem[0]);
              distanceProcessList[index] = editedIngredient;
            }
          });
        } else if (action[0].action === 'delete') {
          const deletedIngredient = action[0].distance;
          const deletedItem = distanceProcessList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          distanceProcessList.splice(distanceProcessList.indexOf(deletedItem[0]), 1);
          distanceProcessList = cloneDeep(distanceProcessList);
        }
        let productIngredientistanceProcessList = Object.assign([], action[2]);
        distanceProcessList.map((x: any) => {
          productIngredientistanceProcessList.push(x);
        });
        return of(
          ProjectsActions.addDistanceTransportSuccess({
            distanceList: distanceProcessList,
            replicaDistanceList: distanceProcessList,
            productIngredientistanceProcessList: productIngredientistanceProcessList,
            error: error,
          })
        );
      })
    )
  );

  addDistanceProductProcess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addDistanceTransportProduct),
      withLatestFrom(this.store.pipe(select(ProjectsSelectors.GetDistanceProductList))),
      exhaustMap(action => {
        let error = '';
        let distanceProductList = Object.assign([], action[1]);
        if (action[0].action == 'reset') {
          distanceProductList = this.addEnableEditing(distanceProductList);
        }
        if (action[0].action === 'add' && distanceProductList.length == 0) {
          if (action[0].distanceProduct) {
            distanceProductList.push({
              ...action[0].distanceProduct,
              index: distanceProductList.length + 1,
              isOrigin: false,
              alwaysOrigin: true,
              isDistance: true,
            });
          }
        } else if (action[0].action === 'add' && distanceProductList.length > 0) {
          distanceProductList = cloneDeep(distanceProductList);
          if (action[0].distanceProduct) {
            if (distanceProductList.find((x: any) => !x.isOrigin && x.alwaysOrigin)) {
              distanceProductList.find((x: any) => !x.isOrigin && x.alwaysOrigin).isOrigin = true;
            }
            distanceProductList.push({
              ...action[0].distanceProduct,
              index: distanceProductList.length + 1,
              isOrigin: false,
              isDistance: true,
            });
          }
        } else if (action[0].action === 'edit') {
          distanceProductList = this.addEnableEditing(distanceProductList);
          distanceProductList.forEach((element: any, index: any) => {
            Object.freeze(action[0].distanceProduct);
            const objCopy = { ...action[0].distanceProduct };
            objCopy.isDistance = true;
            if (distanceProductList.length == 1) {
              distanceProductList[index] = objCopy;
            } else {
              const editedIngredient = objCopy;
              const updatedItem = distanceProductList.filter(
                (data: any) => data.index == action[0].distanceProduct.index
              );
              const index = distanceProductList.indexOf(updatedItem[0]);
              distanceProductList[index] = editedIngredient;
            }
          });
        } else if (action[0].action === 'delete') {
          const deletedIngredient = action[0].distanceProduct;
          const deletedItem = distanceProductList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          distanceProductList.splice(distanceProductList.indexOf(deletedItem[0]), 1);
          distanceProductList = cloneDeep(distanceProductList);
          if (distanceProductList.length == 1) {
            distanceProductList.find((x: any) => (x.isOrigin = false));
          }
        }
        return of(
          ProjectsActions.addDistanceTransportProductSuccess({
            distanceProductList: distanceProductList,
            error: error,
          })
        );
      })
    )
  );

  getCustomFreight$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.getCustomFreight),
      exhaustMap(action => {
        if (!!action.isCustomSiteTransport) {
          return this.projectService.GetCustomSiteTransportList(action.freight).pipe(
            map((data: any) => {
              return ProjectsActions.getCustomFreightSuccess({
                freightList: data.data,
              });
            }),
            catchError((error: any) => of(ProjectsActions.getCustomFreightFailure(error)))
          );
        } else {
          return this.projectService.GetCustomTransportList(action.freight).pipe(
            map((data: any) => {
              return ProjectsActions.getCustomFreightSuccess({
                freightList: data.data,
              });
            }),
            catchError((error: any) => of(ProjectsActions.getCustomFreightFailure(error)))
          );
        }
      })
    )
  );
  getCustomFreightForIngredient$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.getCustomFreightForIngredient),
      exhaustMap(action => {
        if (!!action.isCustomSiteTransport) {
          return this.projectService.GetCustomSiteTransportList(action.freight).pipe(
            map((data: any) => {
              return ProjectsActions.getCustomFreightSuccess({
                freightList: data.data,
              });
            }),
            catchError((error: any) => of(ProjectsActions.getCustomFreightFailure(error)))
          );
        } else {
          return this.projectService.GetCustomTransportList(action.freight).pipe(
            map((data: any) => {
              return ProjectsActions.getCustomFreightSuccess({
                freightList: data.data,
              });
            }),
            catchError((error: any) => of(ProjectsActions.getCustomFreightFailure(error)))
          );
        }
      })
    )
  );

  addComponentTransportProcess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addComponent),
      withLatestFrom(
        this.store.pipe(select(ProjectsSelectors.GetComponentTransport)),
        this.store.pipe(select(ProjectsSelectors.showErrorMsgProject))
      ),
      exhaustMap(action => {
        let error = '';
        let updatedStoreerr: any = Object.assign([], action[2]) || [];
        let isExist;
        let updatedComponentProcessList = Object.assign([], action[1]);
        if (action[0]?.action != 'delete') {
          isExist = action[1].find((x: any) => x?.componentId == action[0]?.component?.componentId);
          error = !!isExist ? 'Components data already exists' : '';
          updatedStoreerr.push(error);
        }
        if (action[0]?.action === 'add' && !isExist && updatedComponentProcessList.length == 0) {
          if (action[0].component) {
            updatedComponentProcessList.push({
              ...action[0].component,
              index: updatedComponentProcessList.length + 1,
              isDistance: true,
            });
          }
        } else if (
          action[0].action === 'add' &&
          !isExist &&
          updatedComponentProcessList.length > 0
        ) {
          updatedComponentProcessList = cloneDeep(updatedComponentProcessList);
          if (action[0].component) {
            if (updatedComponentProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin)) {
              updatedComponentProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin).isOrigin =
                true;
            }
            updatedComponentProcessList.push({
              ...action[0].component,
              index: updatedComponentProcessList.length + 1,
              isDistance: true,
            });
          }
        } else if (action[0].action === 'edit') {
          updatedComponentProcessList.forEach((element: any, index: any) => {
            if (updatedComponentProcessList.length == 1) {
              updatedComponentProcessList[index] = action[0].component;
            } else {
              const editedComponent = action[0].component;
              const updatedItem = updatedComponentProcessList.filter(
                (data: any) => data.index == action[0].component.index
              );
              const index = updatedComponentProcessList.indexOf(updatedItem[0]);
              updatedComponentProcessList[index] = editedComponent;
            }
          });
        } else if (action[0].action === 'delete') {
          const deletedComponent = action[0].component;
          const deletedItem = updatedComponentProcessList.filter(
            (data: any) => data.index == deletedComponent.index
          );
          updatedComponentProcessList.splice(
            updatedComponentProcessList.indexOf(deletedItem[0]),
            1
          );
        }
        return of(
          ProjectsActions.addComponentSuccess({
            componentList: updatedComponentProcessList,
            error: updatedStoreerr,
          })
        );
      })
    )
  );

  addProductTransportProcess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addProduct),
      withLatestFrom(
        this.store.pipe(select(ProjectsSelectors.GetProductTransport)),
        this.store.pipe(select(ProjectsSelectors.storeerr))
      ),
      exhaustMap(action => {
        let error = '';
        let storeerr: any = Object.assign([], action[2]) || [];
        let isExist;
        let productProcessList = Object.assign([], action[1]);
        if (action[0]?.action != 'delete') {
          isExist = action[1].find((x: any) => x?.productId == action[0]?.product?.productId);
          error = !!isExist ? 'product data already exists' : '';
          storeerr.push(error);
        }
        if (action[0]?.action === 'add' && !isExist && productProcessList.length == 0) {
          if (action[0].product) {
            productProcessList.push({
              ...action[0].product,
              index: productProcessList.length + 1,
              isDistance: true,
            });
          }
        } else if (action[0].action === 'add' && !isExist && productProcessList.length > 0) {
          productProcessList = cloneDeep(productProcessList);
          if (action[0].product) {
            if (productProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin)) {
              productProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin).isOrigin = true;
            }
            productProcessList.push({
              ...action[0].product,
              index: productProcessList.length + 1,
              isDistance: true,
            });
          }
        } else if (action[0].action === 'edit') {
          productProcessList.forEach((element: any, index: any) => {
            if (productProcessList.length == 1) {
              productProcessList[index] = action[0].product;
            } else {
              const editedIngredient = action[0].product;
              const updatedItem = productProcessList.filter(
                (data: any) => data.index == action[0].product.index
              );
              const index = productProcessList.indexOf(updatedItem[0]);
              productProcessList[index] = editedIngredient;
            }
          });
        } else if (action[0].action === 'delete') {
          const deletedIngredient = action[0].product;
          const deletedItem = productProcessList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          productProcessList.splice(productProcessList.indexOf(deletedItem[0]), 1);
        }
        return of(
          ProjectsActions.addProductSuccess({ productList: productProcessList, storeerr: storeerr })
        );
      })
    )
  );

  addEditProjectFilling$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addEditProjectFilling),
      exhaustMap(action => {
        return this.projectService.addUpdateProjectFilling(action.fillingPayload).pipe(
          map((data: any) => {
            data['pathName'] = action.fillingPayload.pathName;
            data['scenarioId'] = action.fillingPayload.scenarioId;
            data['projectId'] = action.fillingPayload.projectId;
            return ProjectsActions.addEditProjectFillingSuccess({
              fillingPayload: data,
            });
          }),
          catchError((error: any) => of(ProjectsActions.addEditProjectFillingFailure(error)))
        );
      })
    )
  );

  addEditProjectFillingSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addEditProjectFillingSuccess),
      exhaustMap(action => {
        if (action.fillingPayload.messageType != 0) {
          return of(
            sharedAction.ToasterError({
              description: action.fillingPayload.message,
            })
          );
        } else {
          this.modal.close();
          this.getProjectFillingList();
          return of(
            sharedAction.ToasterSuccess({
              description: action.fillingPayload.message,
            }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  addLocationProcessProduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addLocationProcessProduct),
      withLatestFrom(this.store.pipe(select(ProjectsSelectors.GetLocationProductList))),
      exhaustMap(action => {
        let error = '';
        let distanceError = '';
        let locationProcessList = Object.assign([], action[1]);
        if (action[0].action == 'reset') {
          locationProcessList = this.addEnableEditing(locationProcessList);
        }
        if (action[0].action === 'add' && locationProcessList.length == 0) {
          if (action[0].locationProduct) {
            locationProcessList.push({
              ...action[0].locationProduct,
              index: locationProcessList.length + 1,
              isOrigin: false,
              alwaysOrigin: true,
            });
          }
        } else if (action[0].action === 'add' && locationProcessList.length > 0) {
          locationProcessList = cloneDeep(locationProcessList);
          if (action[0].locationProduct) {
            if (locationProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin)) {
              locationProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin).isOrigin = true;
            }
            locationProcessList.push({
              ...action[0].locationProduct,
              index: locationProcessList.length + 1,
              isOrigin: false,
            });
          }
        } else if (action[0].action === 'edit') {
          locationProcessList = this.addEnableEditing(locationProcessList);
          locationProcessList.forEach((element: any, index: any) => {
            if (locationProcessList.length == 1) {
              locationProcessList[index] = action[0].locationProduct;
            } else {
              const editedIngredient = action[0].locationProduct;
              const updatedItem = locationProcessList.filter(
                (data: any) => data.index == action[0].locationProduct.index
              );
              const index = locationProcessList.indexOf(updatedItem[0]);
              locationProcessList[index] = editedIngredient;
            }
          });
        } else if (action[0].action === 'delete') {
          const deletedIngredient = action[0].locationProduct;
          const deletedItem = locationProcessList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          locationProcessList.splice(locationProcessList.indexOf(deletedItem[0]), 1);
          locationProcessList = cloneDeep(locationProcessList);
          if (locationProcessList.length == 1) {
            locationProcessList.find((x: any) => (x.isOrigin = false));
          }
          locationProcessList = this.deleteCustomProcess(locationProcessList);
        }
        if (locationProcessList.length > 1 && action[0]?.action != 'edit') {
          locationProcessList[0]['isOrigin'] = true;
          locationProcessList[0]['alwaysOrigin'] = true;
        }
        locationProcessList.map((element: any, index: any) => {
          if ((element.distance == '0' || element.distance == '0 km') && index != 0) {
            distanceError = messageConstant.noRecommendedConversionMessage;
          }
        });
        return of(
          ProjectsActions.addLocationProcessProductSuccess({
            locationProductList: locationProcessList,
            error: error,
            distanceError: distanceError,
          })
        );
      })
    )
  );

  //open add edit new project scenario fill data modal
  openNewAddProjectWholesaleDataModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.openNewAddProjectWholesaleDataModal),
      exhaustMap(action => {
        return this.projectService
          .getProjectWholesaleAddUpdateData(action.scenarioId, action.id, action.storageTypeId)
          .pipe(
            map((data: any) => {
              if (action.actionLabel == 'Review wholesale') {
                data.data.locationTransportationItems = data.data.locationTransportationItems.map(
                  (item: any, index: any) => {
                    item.distance = this.setUnit(item);
                    return {
                      ...item,
                      index: index + 1,
                      distance: item.isOrigin ? '' : item.distance,
                    };
                  }
                );
                data.data.distanceTransportationItems = data.data.distanceTransportationItems.map(
                  (item: any, index: any) => {
                    return {
                      ...item,
                      index: index + 1,
                      isCheckManualDis: true,
                    };
                  }
                );
              }
              this.modal.invoke('newAddProjectScenarioWholesale', {
                initialState: {
                  wholesaleData: data.data,
                  label: action.actionLabel,
                  scenarioId: action.scenarioId,
                  projectId: action.projectId,
                },
                class: 'modal-xl',
              });
              this.modal.ref?.content.saveNewMyProjectWholesaleEvent.subscribe(
                (saveNewMyProjectWholesaleEvent: any) => {
                  return of(
                    this.projectFacde.addEditProjectWholesale(saveNewMyProjectWholesaleEvent)
                  );
                }
              );
              return ProjectsActions.openNewAddProjectWholesaleDataSuccess({
                addEditWholesaleModalData: data,
              });
            })
          );
      })
    )
  );

  addLocationProcessForWholesale$ = createEffect(() =>
    // For Wholesale
    this.actions$.pipe(
      ofType(ProjectsActions.addLocationWholesale),
      withLatestFrom(this.store.pipe(select(ProjectsSelectors.GetWholesaleLocationList))),
      exhaustMap(action => {
        let error = '';
        let distanceError = '';
        let locationProcessList = Object.assign([], action[1]);
        if (action[0].action == 'reset') {
          locationProcessList = this.addEnableEditing(locationProcessList);
        }
        if (action[0].action === 'add' && locationProcessList.length == 0) {
          if (action[0].locationWholesale) {
            locationProcessList.push({
              ...action[0].locationWholesale,
              index: locationProcessList.length + 1,
              isOrigin: false,
              alwaysOrigin: true,
            });
          }
        } else if (action[0].action === 'add' && locationProcessList.length > 0) {
          locationProcessList = cloneDeep(locationProcessList);
          if (action[0].locationWholesale) {
            if (locationProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin)) {
              locationProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin).isOrigin = true;
            }
            locationProcessList.push({
              ...action[0].locationWholesale,
              index: locationProcessList.length + 1,
              isOrigin: false,
            });
          }
        } else if (action[0].action === 'edit') {
          locationProcessList = this.addEnableEditing(locationProcessList);
          locationProcessList.forEach((element: any, index: any) => {
            if (locationProcessList.length == 1) {
              locationProcessList[index] = action[0].locationWholesale;
            } else {
              const editedIngredient = action[0].locationWholesale;
              const updatedItem = locationProcessList.filter(
                (data: any) => data.index == action[0].locationWholesale.index
              );
              const index = locationProcessList.indexOf(updatedItem[0]);
              locationProcessList[index] = editedIngredient;
            }
          });
        } else if (action[0].action === 'delete') {
          const deletedIngredient = action[0].locationWholesale;
          const deletedItem = locationProcessList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          locationProcessList.splice(locationProcessList.indexOf(deletedItem[0]), 1);
          locationProcessList = cloneDeep(locationProcessList);
          if (locationProcessList.length == 1) {
            locationProcessList.find((x: any) => (x.isOrigin = false));
          }
        }
        if (locationProcessList.length > 1 && action[0]?.action != 'edit') {
          locationProcessList[0]['isOrigin'] = true;
          locationProcessList[0]['alwaysOrigin'] = true;
        }
        locationProcessList.map((element: any, index: any) => {
          if ((element.distance == '0' || element.distance == '0 km') && index != 0) {
            distanceError = messageConstant.noRecommendedConversionMessage;
          }
        });
        return of(
          ProjectsActions.addLocationWholesaleSuccess({
            locationWholesaleList: locationProcessList,
            error: error,
            distanceError: distanceError,
          })
        );
      })
    )
  );

  addDistanceForWholesale$ = createEffect(() =>
    // For Wholesale
    this.actions$.pipe(
      ofType(ProjectsActions.addDistanceWholesale),
      withLatestFrom(this.store.pipe(select(ProjectsSelectors.GetWholesaleDistanceList))),
      exhaustMap(action => {
        let error = '';
        let wholesaleDistanceList = Object.assign([], action[1]);
        if (action[0].action == 'reset') {
          wholesaleDistanceList = this.addEnableEditing(wholesaleDistanceList);
        }
        if (action[0].action === 'add' && wholesaleDistanceList.length == 0) {
          if (action[0].wholesaleDistance) {
            wholesaleDistanceList.push({
              ...action[0].wholesaleDistance,
              index: wholesaleDistanceList.length + 1,
              isDistance: true,
            });
          }
        } else if (action[0].action === 'add' && wholesaleDistanceList.length > 0) {
          wholesaleDistanceList = cloneDeep(wholesaleDistanceList);
          if (action[0].wholesaleDistance) {
            if (wholesaleDistanceList.find((x: any) => !x.isOrigin && x.alwaysOrigin)) {
              wholesaleDistanceList.find((x: any) => !x.isOrigin && x.alwaysOrigin).isOrigin = true;
            }
            wholesaleDistanceList.push({
              ...action[0].wholesaleDistance,
              index: wholesaleDistanceList.length + 1,
              isDistance: true,
            });
          }
        } else if (action[0].action === 'edit') {
          wholesaleDistanceList = this.addEnableEditing(wholesaleDistanceList);
          wholesaleDistanceList.forEach((element: any, index: any) => {
            Object.freeze(action[0].wholesaleDistance);
            const objCopy = { ...action[0].wholesaleDistance };
            objCopy.isDistance = true;
            if (wholesaleDistanceList.length == 1) {
              wholesaleDistanceList[index] = objCopy;
            } else {
              const editedIngredient = objCopy;
              const updatedItem = wholesaleDistanceList.filter(
                (data: any) => data.index == action[0].wholesaleDistance.index
              );
              const index = wholesaleDistanceList.indexOf(updatedItem[0]);
              wholesaleDistanceList[index] = editedIngredient;
            }
          });
        } else if (action[0].action === 'delete') {
          const deletedIngredient = action[0].wholesaleDistance;
          const deletedItem = wholesaleDistanceList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          wholesaleDistanceList.splice(wholesaleDistanceList.indexOf(deletedItem[0]), 1);
          wholesaleDistanceList = cloneDeep(wholesaleDistanceList);
        }
        return of(
          ProjectsActions.addDistanceWholesaleSuccess({
            wholesaleDistanceList: wholesaleDistanceList,
            error: error,
          })
        );
      })
    )
  );

  getCustomFreightWholesale$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.getCustomFreightWholesale),
      exhaustMap(action => {
        if (!!action.isCustomSiteTransport) {
          return this.projectService.GetCustomSiteTransportList(action.freightWholesale).pipe(
            map((data: any) => {
              return ProjectsActions.getCustomFreightWholesaleSuccess({
                freightWholesaleList: data.data,
              });
            }),
            catchError((error: any) => of(ProjectsActions.getCustomFreightWholesaleFailure(error)))
          );
        } else {
          return this.projectService.GetCustomTransportList(action.freightWholesale).pipe(
            map((data: any) => {
              return ProjectsActions.getCustomFreightWholesaleSuccess({
                freightWholesaleList: data.data,
              });
            }),
            catchError((error: any) => of(ProjectsActions.getCustomFreightWholesaleFailure(error)))
          );
        }
      })
    )
  );

  addEditProjectWholesale$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addEditProjectWholesale),
      exhaustMap(action => {
        return this.projectService.addUpdateProjectWholesale(action.wholesalePayload).pipe(
          map((data: any) => {
            data['pathName'] = action.wholesalePayload.pathName;
            data['scenarioId'] = action.wholesalePayload.scenarioId;
            data['projectId'] = action.wholesalePayload.projectId;
            return ProjectsActions.addEditProjectWholesaleSuccess({
              wholesalePayload: data,
            });
          }),
          catchError((error: any) => of(ProjectsActions.addEditProjectWholesaleFailure(error)))
        );
      })
    )
  );

  addEditProjectWholesaleSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addEditProjectWholesaleSuccess),
      exhaustMap(action => {
        if (action.wholesalePayload.messageType != 0) {
          return of(
            sharedAction.ToasterError({
              description: action.wholesalePayload.message,
            })
          );
        } else {
          this.modal.close();
          this.getProjectWholesaleList();
          return of(
            sharedAction.ToasterSuccess({
              description: action.wholesalePayload.message,
            }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  getCustomFreightForProduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.getCustomFreightProduct),
      exhaustMap(action => {
        if (!!action.isCustomSiteTransport) {
          return this.projectService.GetCustomSiteTransportList(action.freightProduct).pipe(
            map((data: any) => {
              return ProjectsActions.getCustomFreightProductSuccess({
                freightProductList: data.data,
              });
            }),
            catchError((error: any) => of(ProjectsActions.getCustomFreightFailure(error)))
          );
        } else {
          return this.projectService.GetCustomTransportList(action.freightProduct).pipe(
            map((data: any) => {
              return ProjectsActions.getCustomFreightProductSuccess({
                freightProductList: data.data,
              });
            }),
            catchError((error: any) => of(ProjectsActions.getCustomFreightFailure(error)))
          );
        }
      })
    )
  );

  inlineDataEditForProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.inlineDataEditForProject),
      exhaustMap(action => {
        return this.projectService
          .projectRetailAndConsumerInlineEdit(action.projectInlinePayload)
          .pipe(
            map((data: any) => {
              data['pathName'] = action.pathName;
              data['scenarioId'] = action.scenarioId;
              return ProjectsActions.inlineDataEditForProjectSuccess({
                projectInlineData: data,
              });
            }),
            catchError((error: any) => of(ProjectsActions.inlineDataEditForProjectFailure(error)))
          );
      })
    )
  );

  inlineDataEditForProjectSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.inlineDataEditForProjectSuccess),
      exhaustMap(action => {
        const toaster = action.projectInlineData.messageType
          ? sharedAction.ToasterError({ description: action.projectInlineData.message })
          : sharedAction.ToasterSuccess({ description: action.projectInlineData.message });
        switch (action.projectInlineData.pathName) {
          case 'retail-list':
            // eslint-disable-next-line no-case-declarations
            const packRetail = {
              myProjectPackRetailListPaylaod:
                this.projectScenarioRetailDataGridService.getPayload(''),
            };
            this.getRetailListData();
            return of(toaster, sharedAction.clearSearchFilter({ isClearSearch: true }));
            break;
          case 'consumer-list':
            // eslint-disable-next-line no-case-declarations
            const packConsumer = {
              myProjectPackConsumerListPaylaod:
                this.projectScenarioConsumerDataGridService.getPayload(''),
            };
            return of(
              ProjectsActions.getAllMyProjectScenarioConsumerList({
                myProjectScenarioConsumerListPaylaod: packConsumer,
                storagetypeId: this.StorageTypeEnum.Consumer,
                scenarioId: action.projectInlineData.scenarioId,
                projectId: this.projectId,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          default:
            return of(
              sharedAction.ToasterSuccess({ description: 'Record Success' }),
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
        }
      })
    )
  );

  // for material project
  inlineDataEditForProjectMaterial$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.inlineDataEditForProjectMaterial),
      exhaustMap(action => {
        return this.projectService.projectMaterialInlineEdit(action.projectInlinePayload).pipe(
          map((data: any) => {
            data['pathName'] = action.pathName;
            data['scenarioId'] = action.scenarioId;
            return ProjectsActions.inlineDataEditForProjectMaterialSuccess({
              projectMaterialInlineData: data,
            });
          }),
          catchError((error: any) =>
            of(ProjectsActions.inlineDataEditForProjectMaterialFailure(error))
          )
        );
      })
    )
  );
  inlineEditForProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.inlineEditProject),
      exhaustMap(action => {
        return this.projectService
          .projectRetailAndConsumerInlineEdit(action.projectInlineData)
          .pipe(
            map((data: any) => {
              data = { ...data };
              data['pathName'] = action.pathName;
              return ProjectsActions.inlineEditProjectSuccess({
                inlineData: data,
              });
            }),
            catchError((error: any) => of(ProjectsActions.inlineEditProjectFailure(error)))
          );
      })
    )
  );

  inlineEditForProjectSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.inlineEditProjectSuccess),
      exhaustMap(action => {
        let urlEqual = this.router.url.lastIndexOf('=');
        const scenarioId = this.router.url.slice(urlEqual + 1);
        const toaster = action.inlineData.messageType
          ? sharedAction.ToasterError({ description: action.inlineData.message })
          : sharedAction.ToasterSuccess({ description: action.inlineData.message });
        const payload = this.projectScenarioWholesaleDataGridService.getPayload('');
        return of(
          ProjectsActions.getAllMyProjectScenarioWholesaleList({
            myProjectScenarioWholesaleListPaylaod: payload,
            storagetypeId: 1,
            scenarioId: scenarioId,
            projectId: this.projectId,
          }),
          toaster,
          sharedAction.clearSearchFilter({ isClearSearch: true })
        );
      })
    )
  );

  inlineDataEditForProjectMaterialSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.inlineDataEditForProjectMaterialSuccess),
      exhaustMap(action => {
        const toaster = action.projectMaterialInlineData.messageType
          ? sharedAction.ToasterError({ description: action.projectMaterialInlineData.message })
          : sharedAction.ToasterSuccess({ description: action.projectMaterialInlineData.message });
        switch (action.projectMaterialInlineData.pathName) {
          case 'material-list':
            // eslint-disable-next-line no-case-declarations
            const packMaterial = {
              myProjectPackMaterailListPaylaod:
                this.projectPackMaterialDataGridService.getPackMaterialProjectPayload(''),
            };
            return of(
              ProjectsActions.getAllMyProjectPackMaterialList({
                myProjectListPackMaterialPaylaod: packMaterial,
                scenarioId: action.projectMaterialInlineData.scenarioId,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          default:
            return of(
              sharedAction.ToasterSuccess({ description: 'Record Success' }),
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
        }
      })
    )
  );

  inlineEditForScenarioName$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.inlineEditScenarioName),
      exhaustMap(action => {
        return this.projectService.projectScenarioNameInlineEdit(action.scenarioInlineData).pipe(
          map((data: any) => {
            data = { ...data };
            data['pathName'] = action.pathName;
            return ProjectsActions.inlineEditScenarioNameSuccess({
              scenarioData: data,
            });
          }),
          catchError((error: any) => of(ProjectsActions.inlineEditScenarioNameFailure(error)))
        );
      })
    )
  );

  inlineEditForScenarioNameSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.inlineEditScenarioNameSuccess),
      exhaustMap(action => {
        const url = location.href.split('/');
        const activatedRouteProjectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
        const toaster = action.scenarioData.messageType
          ? sharedAction.ToasterError({ description: action.scenarioData.message })
          : sharedAction.ToasterSuccess({ description: action.scenarioData.message });
        const payload = this.projectScenarioDataGridService.getPayload('');
        return of(
          ProjectsActions.getAllMyProjectScenarioList({
            myProjectListPaylaod: payload,
            projectId: activatedRouteProjectId,
            scenarioTypeId: 1,
          }),
          toaster,
          sharedAction.clearSearchFilter({ isClearSearch: true })
        );
      })
    )
  );

  organizationDataMapProcess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.organizationDataMapProcess),
      withLatestFrom(this.store.pipe(select(ProjectsSelectors.organizationItemsSelector))),
      exhaustMap(action => {
        let organizationDataMapList = Object.assign([], action[1]) || [];
        let dummyOrganizationDataList = Object.assign([], action[1]) || [];
        let errorMessage = false;
        if (organizationDataMapList.length) {
          const existRecord = organizationDataMapList.filter((x: any) => {
            return (
              x.name.toString().toLowerCase() ==
                action[0].organization.name.toString().toLowerCase() &&
              x.index != action[0].organization.index
            );
          });

          if (existRecord.length) {
            errorMessage = true;
          }
        }
        if (action[0].action === 'add') {
          if (action[0].organization) {
            organizationDataMapList.unshift({
              ...action[0].organization,
              index: organizationDataMapList.length + 1,
            });
          }
        }
        if (action[0].action === 'edit' && !errorMessage) {
          organizationDataMapList = this.addEnableEditing(organizationDataMapList);
          organizationDataMapList.forEach((element: any, indx: any) => {
            const updatedItem = organizationDataMapList.filter(
              (data: any) => data.index == action[0].organization.index
            );
            const index = organizationDataMapList.indexOf(updatedItem[0]);
            if (action[0].colId == 'Name') {
              organizationDataMapList[index]['name'] = action[0].organization.name;
            } else if (action[0].colId == 'materialName') {
              organizationDataMapList[index]['materialName'] = action[0].organization.materialName;
              organizationDataMapList[index]['materialId'] = action[0].organization.materialId;
            } else if (action[0].colId == 'conversionName') {
              organizationDataMapList[index]['conversionName'] =
                action[0].organization.conversionName;
              organizationDataMapList[index]['conversionId'] = action[0].organization.conversionId;
            }
          });
        }
        if (action[0].action === 'delete') {
          const deletedIngredient = action[0].organization;
          const deletedItem = organizationDataMapList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          organizationDataMapList.splice(organizationDataMapList.indexOf(deletedItem[0]), 1);
          organizationDataMapList = this.deleteCustomProcess(organizationDataMapList);
          errorMessage = false;
        }
        const checkAPiCall = localStorage.getItem('isCheckOrganizationMapExist');
        const checkEmptyName = localStorage.getItem('checkEmptyNameOrganization');

        if (checkEmptyName == 'Empty' && action[0].colId == 'Name') {
          return of(sharedAction.ToasterError({ description: 'Please enter valid name' }));
        }

        if (errorMessage) {
          localStorage.setItem('isCheckOrganizationMapExist', 'true');
          return of(sharedAction.ToasterError({ description: 'Name already exists' }));
        }

        this.sharedService.passOrgMapData(organizationDataMapList);
        return of(
          ProjectsActions.organizationDataMapProcessSuccess({
            organizationItems:
              checkAPiCall != 'true' && checkEmptyName != 'Empty'
                ? organizationDataMapList
                : dummyOrganizationDataList,
            errorMessage: errorMessage,
            columnName: action[0].colId,
          })
        );
      })
    )
  );

  organizationPreferencesDataMapProcess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.organizationPreferencesDataMapProcess),
      withLatestFrom(
        this.store.pipe(select(ProjectsSelectors.organizationPreferencesItemsSelector))
      ),
      exhaustMap(action => {
        let organizationDataMapList = Object.assign([], action[1]) || [];
        let dummyOrganizationDataList = Object.assign([], action[1]) || [];
        let errorMessage = false;
        if (organizationDataMapList.length) {
          const existRecord = organizationDataMapList.filter((x: any) => {
            return (
              x.name.toString().toLowerCase() ==
                action[0].organization.name.toString().toLowerCase() &&
              x.index != action[0].organization.index
            );
          });

          if (existRecord.length) {
            errorMessage = true;
          }
        }

        if (action[0].action === 'edit' && !errorMessage) {
          organizationDataMapList = this.addEnableEditing(organizationDataMapList);
          organizationDataMapList.forEach((element: any, indx: any) => {
            const updatedItem = organizationDataMapList.filter(
              (data: any) => data.index == action[0].organization.index
            );
            const index = organizationDataMapList.indexOf(updatedItem[0]);
            if (action[0].colId == 'Name') {
              organizationDataMapList[index]['name'] = action[0].organization.name;
            } else if (action[0].colId == 'materialName') {
              organizationDataMapList[index]['materialName'] = action[0].organization.materialName;
              organizationDataMapList[index]['materialId'] = action[0].organization.materialId;
            } else if (action[0].colId == 'conversionName') {
              organizationDataMapList[index]['conversionName'] =
                action[0].organization.conversionName;
              organizationDataMapList[index]['conversionId'] = action[0].organization.conversionId;
            }
          });
        }
        if (action[0].action === 'delete') {
          const deletedIngredient = action[0].organization;
          const deletedItem = organizationDataMapList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          organizationDataMapList.splice(organizationDataMapList.indexOf(deletedItem[0]), 1);
          organizationDataMapList = this.deleteCustomProcess(organizationDataMapList);
          errorMessage = false;
        }
        const checkAPiCall = localStorage.getItem('isCheckOrganizationMapExist');
        const checkEmptyName = localStorage.getItem('checkEmptyNameOrganization');

        if (checkEmptyName == 'Empty' && action[0].colId == 'Name') {
          return of(sharedAction.ToasterError({ description: 'Please enter valid name' }));
        }

        if (errorMessage) {
          localStorage.setItem('isCheckOrganizationMapExist', 'true');
          return of(sharedAction.ToasterError({ description: 'Name already exists' }));
        }

        if (checkAPiCall != 'true' && checkEmptyName != 'Empty') {
          if (action[0].action === 'edit' && action[0].colId == 'conversionName' && !errorMessage) {
            this.projectFacde.saveOrganizationPreferenceProcess(
              organizationDataMapList.find((x: any) => x.id == action[0].organization.id)
            );
          }
        }
        this.sharedService.passOrgMapData(organizationDataMapList);
        return of(
          ProjectsActions.organizationPreferencesDataMapProcessSuccess({
            organizationItems:
              checkAPiCall != 'true' && checkEmptyName != 'Empty'
                ? organizationDataMapList
                : dummyOrganizationDataList,
            errorMessage: errorMessage,
            columnName: action[0].colId,
          })
        );
      })
    )
  );

  saveOrganizationPreferenceProcess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.saveOrganizationPreferenceProcess),
      exhaustMap(action => {
        const payload = {
          name: action.payload.name,
          materialId: action.payload.materialId,
          id: action.payload.id,
          conversionId: action.payload.conversionId,
        };
        return this.myOrganizationService.saveOrganizationMapPreferenceData(payload).pipe(
          map((data: any) => {
            if (data.messageType) {
              return sharedAction.ToasterError({ description: data.message });
            } else {
              return sharedAction.ToasterSuccess({ description: data.message });
            }
          })
        );
      })
    )
  );

  proudctIngredientProcess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.proudctIngredientProcess),
      withLatestFrom(this.store.pipe(select(ProjectsSelectors.getIngredientItems))),
      exhaustMap(action => {
        let ingredientList = Object.assign([], action[1]) || [];
        let errorMessage = '';
        if (
          action[0].ingredient.ingredientWeight === 0 ||
          action[0].ingredient.ingredientWeight === '' ||
          action[0].ingredient.ingredientWeight == null
        ) {
          return of(ProjectsActions.proudctIngredientProcessFailure({ error: errorMessage }));
        }
        let currentIndex = ingredientList.findIndex(
          (x: any) => x.ingredientItemId == action[0].ingredient.ingredientItemId
        );

        const isDuplicate = ingredientList.some(
          (r: any, i: any) =>
            r.ingredientItemId === action[0].ingredient.ingredientItemId &&
            currentIndex != action[0].rowId
        );
        if (isDuplicate) {
          errorMessage = 'Ingredient already exists.';
        }

        if (action[0].action === 'add' && !isDuplicate) {
          if (action[0].ingredient) {
            ingredientList.push({ ...action[0].ingredient, index: ingredientList.length + 1 });
            this.sharedService.getLatestIngredientTrasnport(ingredientList);
          }
        }
        if (action[0].action === 'edit' && !isDuplicate) {
          ingredientList = this.addEnableEditing(ingredientList);
          ingredientList.forEach((element: any, indx: any) => {
            const updatedItem = ingredientList.filter(
              (data: any) => data.index == action[0].ingredient.index
            );
            const index = ingredientList.indexOf(updatedItem[0]);
            if (action[0].colId == 'ingredientName') {
              ingredientList[index]['ingredientItemId'] = action[0].ingredient.ingredientItemId;
              ingredientList[index]['ingredientName'] = action[0].ingredient.ingredientName;
            } else if (action[0].colId == 'IngredientWeight') {
              ingredientList[index]['ingredientWeight'] = action[0].ingredient.ingredientWeight;
            } else if (action[0].colId == 'unitName') {
              ingredientList[index]['unitName'] = action[0].ingredient.unitName;
            } else if (action[0].colId == 'countryName') {
              ingredientList[index]['countryName'] = action[0].ingredient.countryName;
              ingredientList[index]['countryId'] = action[0].ingredient.countryId;
            } else if (action[0].colId == 'supplierName') {
              ingredientList[index]['supplierName'] = action[0].ingredient.supplierName;
              ingredientList[index]['ingredientSupplierId'] =
                action[0].ingredient.ingredientSupplierId;
            }
          });
        }
        if (action[0].action === 'delete') {
          const deletedIngredient = action[0].ingredient;
          const deletedItem = ingredientList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          ingredientList.splice(ingredientList.indexOf(deletedItem[0]), 1);
          ingredientList = this.deleteCustomProcess(ingredientList);
          this.sharedService.getLatestIngredientTrasnport(ingredientList);
          errorMessage = '';
        }

        return of(
          ProjectsActions.proudctIngredientProcessSuccess({
            ingredientItems: ingredientList,
            errorMessage: errorMessage,
            columnName: action[0].colId,
          })
        );
      })
    )
  );

  proudctIngredientProcessSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.proudctIngredientProcessSuccess),
      withLatestFrom(this.store.pipe(select(ProjectsSelectors.getIngredientTransportItems))),
      exhaustMap(action => {
        if (action[0].columnName == 'ingredientName') {
          let ingredientTransportList = Object.assign([], action[1]);
          let errorMessage = action[0].errorMessage;
          const ingredientItemIds = action[0].ingredientItems.map(
            (item: any) => item.ingredientItemId
          );
          const filteredArr = ingredientTransportList.filter((item: any) =>
            ingredientItemIds.includes(item.transportaionIngredientId)
          );
          this.sharedService.getLatestIngredientTrasnport(action[0].ingredientItems);
          return of(
            ProjectsActions.proudctIngredientTransportProcessSuccess({
              ingredientTransportList: filteredArr,
              errorMessage: errorMessage,
            })
          );
        }
        return of();
      })
    )
  );

  // effect for get all my project eol reuse list
  projectEOLReuseList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.projectEOLReuseList),
      exhaustMap(action => {
        return this.projectService
          .getProjectEOLRetail(action.payload.payload || action.payload, action.scenarioId)
          .pipe(
            map((data: any) => {
              return ProjectsActions.projectEOLReuseListSuccess({
                eolResueList: data.data,
              });
            }),
            catchError((error: any) => of(ProjectsActions.projectEOLReuseListFailure(error)))
          );
      })
    )
  );

  projectEOLReuseListSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.projectEOLReuseListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );
  // effect for get all my project eol consumer list
  projectEOLConsumerist$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.projectEOLConsumerist),
      exhaustMap(action => {
        return this.projectService
          .getProjectEOLConsumer(action.payload.payload || action.payload, action.scenarioId)
          .pipe(
            map((data: any) => {
              return ProjectsActions.projectEOLConsumeristSuccess({
                eolConsumerList: data.data,
              });
            }),
            catchError((error: any) => of(ProjectsActions.projectEOLConsumeristFailure(error)))
          );
      })
    )
  );

  projectEOLConsumeristSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.projectEOLConsumeristSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );
  //For ingredient trasnport
  proudctIngredientTransportProcess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.proudctIngredientTransportProcess),
      withLatestFrom(
        this.store.pipe(select(ProjectsSelectors.getIngredientTransportItems)),
        this.store.pipe(select(ProjectsSelectors.GetDistanceList)),
        this.store.pipe(select(ProjectsSelectors.GetLocationList)),
        this.store.pipe(select(ProjectsSelectors.GetFreightList))
      ),
      exhaustMap(action => {
        let ingredientTransportList = Object.assign([], action[1]);
        let ingredientDistanceTransportList = Object.assign(
          [],
          action[0].ingredient.distanceTransportationItems
        );
        let ingredientlocationTransportList = Object.assign([], action[3]);
        let ingredientCustomTransportList = Object.assign([], action[4]);
        let errorMessage = '';
        let isExist = action[1].find(
          (x: any) =>
            (x.ingredientItemId || x.transportaionIngredientId) ==
            action[0].ingredient.ingredientItemId
        );
        ingredientTransportList = cloneDeep(ingredientTransportList);
        if (!isExist && action[0].action === 'add') {
          if (action[0].ingredient) {
            const transportIds = [];
            transportIds.push(action[0].ingredient.transportaionId);
            ingredientTransportList.push({
              ...action[0].ingredient,
              transportationIds: transportIds,
              index: ingredientTransportList.length + 1,
            });
          }
        }
        if (isExist && action[0].action === 'add') {
          const getIndex = ingredientTransportList.findIndex(
            (data: any) =>
              (data.ingredientItemId || data.transportaionIngredientId) ==
              action[0].ingredient.ingredientItemId
          );
          const transportIds = [];
          if (typeof ingredientTransportList[getIndex].transportaionId === 'number') {
            transportIds.push(
              ingredientTransportList[getIndex].transportaionId,
              action[0].ingredient.transportaionId
            );
          } else {
            transportIds.push(
              ...ingredientTransportList[getIndex].transportaionId,
              action[0].ingredient.transportaionId
            );
          }
          const transportIcons = [];
          transportIcons.push(
            ...ingredientTransportList[getIndex].transportIcons,
            ...action[0].ingredient.transportIcons
          );
          const locationData = [];
          locationData.push(
            ...ingredientTransportList[getIndex].locationTransportationItems,
            ...action[0].ingredient.locationTransportationItems
          );
          const distanceData = [];
          distanceData.push(
            ...ingredientTransportList[getIndex].distanceTransportationItems,
            ...action[0].ingredient.distanceTransportationItems
          );

          const customeLocationTransportationItems = [];

          // Extract and push customtransportScenarioId from ingredientTransportList
          ingredientTransportList[getIndex].customeLocationTransportationItems?.length > 0 &&
            ingredientTransportList[getIndex].customeLocationTransportationItems.forEach(
              (item: any) => {
                if (item?.customtransportScenarioId) {
                  customeLocationTransportationItems.push(item);
                }
              }
            );
          // Push customtransportScenarioId from action
          const customTransportScenarioIdFromAction =
            action[0].ingredient.customeLocationTransportationItems;
          if (!!customTransportScenarioIdFromAction[0]) {
            customeLocationTransportationItems.push(
              action[0].ingredient.customeLocationTransportationItems[0]
            );
          }
          const list: any = {};
          list['ingredientItemId'] = action[0].ingredient.ingredientItemId;
          list['index'] = ingredientTransportList[getIndex].index;
          list['ingredientName'] = action[0].ingredient.ingredientName;
          list['transportIcons'] = transportIcons;
          list['transportaionId'] = transportIds;
          list['transportationIds'] = transportIds;
          list['locationTransportationItems'] = locationData;
          list['distanceTransportationItems'] = distanceData;
          list['customeLocationTransportationItems'] = customeLocationTransportationItems;
          list['distance'] =
            action[0].ingredient.transportIcons
              .concat(isExist.transportIcons)
              .map((item: any) => item.distance || 0) // Handle null/undefined distances
              .reduce((acc: number, curr: number) => acc + curr, 0) +
            ' ' +
            'km';
          ingredientTransportList[getIndex] = list;
        }
        if (action[0].action === 'delete') {
          const deletedIngredient = action[0].ingredient;
          const deletedItem = ingredientTransportList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          ingredientTransportList.splice(ingredientTransportList.indexOf(deletedItem[0]), 1);
          ingredientTransportList = this.deleteCustomProcess(ingredientTransportList);
          errorMessage = '';
        }
        return of(
          ProjectsActions.proudctIngredientTransportProcessSuccess({
            ingredientTransportList: ingredientTransportList,
            errorMessage: errorMessage,
          })
        );
      })
    )
  );
  //For ingredient manufacture
  proudctIngredientManufactureProcess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.proudctIngredientManufactureProcess),
      withLatestFrom(this.store.pipe(select(ProjectsSelectors.getManufacturProcess))),
      exhaustMap(action => {
        let ingredientManctureList = Object.assign([], action[1]);
        if (action[0].action === 'add') {
          if (action[0].ingredient) {
            ingredientManctureList.push({
              ...action[0].ingredient,
              index: ingredientManctureList.length + 1,
            });
          }
        } else if (action[0].action === 'edit') {
          ingredientManctureList = this.addEnableEditing(ingredientManctureList);
          ingredientManctureList.forEach((element: any, index: any) => {
            if (ingredientManctureList.length == 1) {
              ingredientManctureList[index] = action[0].ingredient;
            } else {
              const editedIngredient = action[0].ingredient;
              const updatedItem = ingredientManctureList.filter(
                (data: any) => data.index == action[0].ingredient.index
              );
              const index = ingredientManctureList.indexOf(updatedItem[0]);
              ingredientManctureList[index] = editedIngredient;
            }
          });
        }
        if (action[0].action === 'delete') {
          const deletedIngredient = action[0].ingredient;
          const deletedItem = ingredientManctureList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          ingredientManctureList.splice(ingredientManctureList.indexOf(deletedItem[0]), 1);
          ingredientManctureList = this.deleteCustomProcess(ingredientManctureList);
        }
        return of(
          ProjectsActions.proudctIngredientManufactureProcessSuccess({
            getManufacturProcessList: ingredientManctureList,
          })
        );
      })
    )
  );

  addLocationProcessIngredient$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addLocationProcessIngredient),
      withLatestFrom(
        this.store.pipe(select(ProjectsSelectors.GetLocationList)),
        this.store.pipe(select(ProjectsSelectors.GetReplicaLocationList))
      ),
      exhaustMap(action => {
        let error = '';
        let distanceError = '';
        let locationProcessList = Object.assign([], action[1]);
        let replicalocation = Object.assign([], action[2]);
        if (action[0].action === 'add' && locationProcessList.length == 0) {
          if (action[0].location) {
            locationProcessList.push({
              ...action[0].location,
              index: locationProcessList.length + 1,
              isOrigin: false,
              alwaysOrigin: true,
            });
          }
        } else if (action[0].action === 'add' && locationProcessList.length > 0) {
          locationProcessList = cloneDeep(locationProcessList);
          if (action[0].location) {
            if (locationProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin)) {
              locationProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin).isOrigin = true;
            }
            locationProcessList.push({
              ...action[0].location,
              index: locationProcessList.length + 1,
              isOrigin: false,
            });
            // replicalocation.push(...locationProcessList);
            replicalocation.push({
              ...action[0].location,
              index: locationProcessList.length + 1,
              isOrigin: false,
            });
          }
        } else if (action[0].action === 'edit') {
          locationProcessList = this.addEnableEditing(locationProcessList);
          locationProcessList.forEach((element: any, index: any) => {
            if (locationProcessList.length == 1) {
              locationProcessList[index] = action[0].location;
            } else {
              const editedIngredient = action[0].location;
              const updatedItem = locationProcessList.filter(
                (data: any) => data.index == action[0].location.index
              );
              const index = locationProcessList.indexOf(updatedItem[0]);
              locationProcessList[index] = editedIngredient;
            }
          });
        } else if (action[0].action === 'delete') {
          const deletedIngredient = action[0].location;
          const deletedItem = locationProcessList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          locationProcessList.splice(locationProcessList.indexOf(deletedItem[0]), 1);
          locationProcessList = cloneDeep(locationProcessList);
          if (locationProcessList.length == 1) {
            locationProcessList.find((x: any) => (x.isOrigin = false));
          }
          locationProcessList = this.deleteCustomProcess(locationProcessList);
        }
        if (locationProcessList.length > 1 && action[0]?.action != 'edit') {
          locationProcessList[0]['isOrigin'] = true;
          locationProcessList[0]['alwaysOrigin'] = true;
        }
        locationProcessList.map((element: any, index: any) => {
          if ((element.distance == '0' || element.distance == '0 km') && index != 0) {
            distanceError = messageConstant.noRecommendedConversionMessage;
          }
        });
        return of(
          ProjectsActions.addLocationProcessIngredientSuccess({
            locationList: locationProcessList,
            replicaLocation: locationProcessList,
            error: error,
            distanceError: distanceError,
          })
        );
      })
    )
  );

  addDistanceTransportIngredeint$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addDistanceTransportIngredeint),
      withLatestFrom(
        this.store.pipe(select(ProjectsSelectors.GetDistanceList)),
        this.store.pipe(select(ProjectsSelectors.GetReplicaDistanceList))
      ),
      exhaustMap(action => {
        let error = '';
        let distanceProcessList = Object.assign([], action[1]);
        let replicadistance = Object.assign([], action[2]);
        let allDistanceList = replicadistance.concat(action[0].distance);

        if (action[0].action === 'add' && distanceProcessList.length == 0) {
          if (action[0].distance) {
            distanceProcessList.push({
              ...action[0].distance,
              index: distanceProcessList.length + 1,
            });
          }
        } else if (distanceProcessList.length > 0 && action[0].action === 'add') {
          if (action[0].distance) {
            if (
              distanceProcessList.find(
                (x: any) => x.hasOwnProperty('cityId') && x.cityId == action[0].distance.cityId
              )
            ) {
              error = 'Record is already exist.';
            } else {
              distanceProcessList = cloneDeep(distanceProcessList);
              if (distanceProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin)) {
                distanceProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin).isOrigin = true;
              }
              distanceProcessList.push({
                ...action[0].distance,
                index: distanceProcessList.length + 1,
                isOrigin: false,
              });
            }
          }
        } else if (action[0].action === 'edit') {
          distanceProcessList = this.addEnableEditing(distanceProcessList);
          distanceProcessList.forEach((element: any, index: any) => {
            Object.freeze(action[0].distance);
            const objCopy = { ...action[0].distance };
            if (distanceProcessList.length == 1) {
              distanceProcessList[index] = objCopy;
            } else {
              const editedIngredient = objCopy;
              const updatedItem = distanceProcessList.filter(
                (data: any) => data.index == action[0].distance.index
              );
              const index = distanceProcessList.indexOf(updatedItem[0]);
              distanceProcessList[index] = editedIngredient;
            }
          });
        } else if (action[0].action === 'delete') {
          const deletedIngredient = action[0].distance;
          const deletedItem = distanceProcessList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          distanceProcessList.splice(distanceProcessList.indexOf(deletedItem[0]), 1);
          distanceProcessList = cloneDeep(distanceProcessList);
          if (distanceProcessList.length == 1) {
            distanceProcessList.find((x: any) => (x.isOrigin = false));
          }
        }
        let productIngredientistanceProcessList = Object.assign([], action[2]);
        distanceProcessList.map((x: any) => {
          productIngredientistanceProcessList.push(x);
        });
        return of(
          ProjectsActions.addDistanceTransportIngredeintSuccess({
            distanceList: distanceProcessList,
            replicaDistanceList: allDistanceList,
            productIngredientistanceProcessList: productIngredientistanceProcessList,
            error: error,
          })
        );
      })
    )
  );

  // eol pre retail open modal

  openAddEditEolPreRetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.openAddEditEolPreRetail),
      exhaustMap(action => {
        if (action.pathName == 'preRetail') {
          return this.projectService
            .openAddEditPreRetail(action.scenarioId, action.reuseFillingId, action.storagetypeId)
            .pipe(
              map((data: any) => {
                if (action.actionLabel == 'Review reuse data') {
                  data.data.addReuseFillingDatalistIteams =
                    data.data.addReuseFillingDatalistIteams.map((item: any) => {
                      return {
                        ...item,
                        index: item.id,
                      };
                    });
                  data.data.addReuseFillingDatalistIteams.forEach((item: any) => {
                    item.fillingTransportDetail.forEach((transport: any) => {
                      transport.cityName = transport.originName; // Add cityname key and assign the value of originName to it
                    });
                  });
                  data.data.addReuseFillingDatalistIteams.forEach((item: any) => {
                    item.reuseFillingProcessItems = item.reuseFillingProcessItems.map((x: any) => {
                      return {
                        ...x,
                        index: x.id,
                      };
                    });
                    item.distanceTransportationItems = item.distanceTransportationItems.map(
                      (x: any) => {
                        return {
                          ...x,
                          index: x.id,
                        };
                      }
                    );
                    item.locationTransportationItems = item.locationTransportationItems.map(
                      (x: any) => {
                        x.distance = this.setUnit(x);
                        return {
                          ...x,
                          index: x.id,
                          distance: x.isOrigin ? '' : x.distance,
                        };
                      }
                    );
                  });
                }
                this.openAddEditEolPreRetail(data, action);
                return ProjectsActions.openAddEditEolPreRetailSuccess({
                  eolPreRetailData: data,
                });
              })
            );
        } else {
          return this.projectService
            .openAddEditPostRetail(action.scenarioId, action.reuseFillingId, action.storagetypeId)
            .pipe(
              map((data: any) => {
                if (action.actionLabel == 'Review reuse data') {
                  data.data.addReuseFillingDatalistIteams =
                    data.data.addReuseFillingDatalistIteams.map((item: any) => {
                      return {
                        ...item,
                        index: item.id,
                      };
                    });
                }
                this.openAddEditEolPreRetail(data, action);
                return ProjectsActions.openAddEditEolPreRetailSuccess({
                  eolPreRetailData: data,
                });
              })
            );
        }
      })
    )
  );

  // transport manual location

  manudaLocationPreRetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.manudaLocationPreRetail),
      withLatestFrom(
        this.store.pipe(select(ProjectsSelectors.getTransportScenarioManudalLocationList))
      ),
      exhaustMap(action => {
        let error = '';
        let distanceError = '';
        let transportScenarioManualLocationList = Object.assign([], action[1]);
        if (action[0].action == 'reset') {
          transportScenarioManualLocationList = this.addEnableEditing(
            transportScenarioManualLocationList
          );
        }
        if (action[0].action === 'add' && transportScenarioManualLocationList.length == 0) {
          if (action[0].transport) {
            transportScenarioManualLocationList.push({
              ...action[0].transport,
              index: transportScenarioManualLocationList.length + 1,
              isOrigin: false,
              alwaysOrigin: true,
            });
          }
        } else if (transportScenarioManualLocationList.length > 0 && action[0].action === 'add') {
          if (action[0].transport) {
            if (
              transportScenarioManualLocationList.find(
                (x: any) => x.hasOwnProperty('cityId') && x.cityId == action[0].transport.cityId
              )
            ) {
              error = 'Record is already exist.';
            } else {
              transportScenarioManualLocationList = cloneDeep(transportScenarioManualLocationList);
              if (
                transportScenarioManualLocationList.find((x: any) => !x.isOrigin && x.alwaysOrigin)
              ) {
                transportScenarioManualLocationList.find(
                  (x: any) => !x.isOrigin && x.alwaysOrigin
                ).isOrigin = true;
              }
              transportScenarioManualLocationList.push({
                ...action[0].transport,
                index: transportScenarioManualLocationList.length + 1,
                isOrigin: false,
              });
            }
          }
        }
        if (action[0].action === 'edit') {
          transportScenarioManualLocationList = this.addEnableEditing(
            transportScenarioManualLocationList
          );
          transportScenarioManualLocationList.forEach((element: any, index: any) => {
            if (transportScenarioManualLocationList.length == 1) {
              transportScenarioManualLocationList[index] = action[0].transport;
            } else {
              const editedIngredient = action[0].transport;
              const updatedItem = transportScenarioManualLocationList.filter(
                (data: any) => data.index == action[0].transport.index
              );
              const index = transportScenarioManualLocationList.indexOf(updatedItem[0]);
              transportScenarioManualLocationList[index] = editedIngredient;
            }
          });
        }
        if (action[0].action === 'delete') {
          const deletedIngredient = action[0].transport;
          const deletedItem = transportScenarioManualLocationList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          transportScenarioManualLocationList.splice(
            transportScenarioManualLocationList.indexOf(deletedItem[0]),
            1
          );
          transportScenarioManualLocationList = cloneDeep(transportScenarioManualLocationList);
          if (transportScenarioManualLocationList.length == 1) {
            transportScenarioManualLocationList.find((x: any) => (x.isOrigin = false));
          }
          transportScenarioManualLocationList = this.deleteCustomProcess(
            transportScenarioManualLocationList
          );
        }
        if (transportScenarioManualLocationList.length > 1 && action[0]?.action != 'edit') {
          transportScenarioManualLocationList[0]['isOrigin'] = true;
          transportScenarioManualLocationList[0]['alwaysOrigin'] = true;
        }
        transportScenarioManualLocationList.map((element: any, index: any) => {
          if ((element.distance == '0' || element.distance == '0 km') && index != 0) {
            distanceError = messageConstant.noRecommendedConversionMessage;
          }
        });

        return of(
          ProjectsActions.manudaLocationPreRetailSuccess({
            transportScenarioManualLocationList: transportScenarioManualLocationList,
            duplicateManualLocation: transportScenarioManualLocationList,
            error: error,
            distanceError: distanceError,
          })
        );
      })
    )
  );

  // manual distance pre retail
  manudaDistancePreRetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.manudaDistancePreRetail),
      withLatestFrom(
        this.store.pipe(select(ProjectsSelectors.getTransportScenarioManualDistanceList))
      ),
      exhaustMap(action => {
        let error = '';
        let transportScenarioManualDistanceList = Object.assign([], action[1]);
        if (action[0].action == 'reset') {
          transportScenarioManualDistanceList = this.addEnableEditing(
            transportScenarioManualDistanceList
          );
        }
        if (action[0].action === 'add' && transportScenarioManualDistanceList.length == 0) {
          if (action[0].transport) {
            transportScenarioManualDistanceList.push({
              ...action[0].transport,
              index: transportScenarioManualDistanceList.length + 1,
            });
          }
        } else if (transportScenarioManualDistanceList.length > 0 && action[0].action === 'add') {
          if (action[0].transport) {
            if (
              transportScenarioManualDistanceList.find(
                (x: any) => x.hasOwnProperty('cityId') && x.cityId == action[0].transport.cityId
              )
            ) {
              error = 'Record is already exist.';
            } else {
              transportScenarioManualDistanceList = cloneDeep(transportScenarioManualDistanceList);
              if (
                transportScenarioManualDistanceList.find((x: any) => !x.isOrigin && x.alwaysOrigin)
              ) {
                transportScenarioManualDistanceList.find(
                  (x: any) => !x.isOrigin && x.alwaysOrigin
                ).isOrigin = true;
              }
              transportScenarioManualDistanceList.push({
                ...action[0].transport,
                index: transportScenarioManualDistanceList.length + 1,
                isOrigin: false,
              });
            }
          }
        } else if (action[0].action === 'edit') {
          transportScenarioManualDistanceList = this.addEnableEditing(
            transportScenarioManualDistanceList
          );
          transportScenarioManualDistanceList.forEach((element: any, index: any) => {
            Object.freeze(action[0].transport);
            const objCopy = { ...action[0].transport };
            objCopy.isDistance = true;
            if (transportScenarioManualDistanceList.length == 1) {
              transportScenarioManualDistanceList[index] = objCopy;
            } else {
              const editedIngredient = objCopy;
              const updatedItem = transportScenarioManualDistanceList.filter(
                (data: any) => data.index == action[0].transport.index
              );
              const index = transportScenarioManualDistanceList.indexOf(updatedItem[0]);
              transportScenarioManualDistanceList[index] = editedIngredient;
            }
          });
        }
        if (action[0].action === 'delete') {
          const deletedIngredient = action[0].transport;
          const deletedItem = transportScenarioManualDistanceList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          transportScenarioManualDistanceList.splice(
            transportScenarioManualDistanceList.indexOf(deletedItem[0]),
            1
          );
        }
        transportScenarioManualDistanceList = this.deleteCustomProcess(
          transportScenarioManualDistanceList
        );
        return of(
          ProjectsActions.manudaDistancePreRetailSuccess({
            transportScenarioManualDistanceList: transportScenarioManualDistanceList,
            duplicateManualDistance: transportScenarioManualDistanceList,
            error: error,
          })
        );
      })
    )
  );

  eolPreRetailAddComponent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.eolPreRetailAddComponent),
      withLatestFrom(this.store.pipe(select(ProjectsSelectors.getComponentPreRetailList))),
      exhaustMap(action => {
        let error = '';
        let isExist: any = [];
        let componentProcessList = Object.assign([], action[1]);
        if (action[0]?.action != 'delete' && action[0]?.action != 'inlineEdit') {
          const isExist = action[1].filter((x: any) =>
            action[0]?.component?.some((component: any) => component?.componentId == x?.componentId)
          );
          error =
            isExist.length > 0 && action[0].action != 'edit' ? `Component data already exists` : '';
        }
        if (action[0].action === 'add' && !isExist.length && componentProcessList.length == 0) {
          if (action[0].component) componentProcessList = action[0].component;
        } else if (
          action[0].action === 'add' &&
          !isExist.length &&
          componentProcessList.length > 0
        ) {
          componentProcessList = cloneDeep(componentProcessList);
          if (action[0].component) {
            if (componentProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin)) {
              componentProcessList.find((x: any) => !x.isOrigin && x.alwaysOrigin).isOrigin = true;
            }
            let tempArr = [...action[1]];
            action[0].component.forEach((x: any) => tempArr.push(x));
            componentProcessList = tempArr;
          }
        } else if (action[0].action === 'add' && !!isExist && componentProcessList.length > 0) {
          let updatedArr = action[0].component?.filter((x: any, i: any) => {
            return x.componentId !== isExist[i]?.componentId;
          });
          componentProcessList = componentProcessList.concat(updatedArr);
        } else if (action[0].action === 'inlineEdit') {
          componentProcessList.forEach((element: any, index: any) => {
            if (componentProcessList.length == 1) {
              componentProcessList[index] = action[0].component;
            } else {
              const editedIngredient = action[0].component;
              const updatedItem = componentProcessList.filter(
                (data: any) => data.index == action[0].component.index
              );
              const index = componentProcessList.indexOf(updatedItem[0]);
              componentProcessList[index] = editedIngredient;
            }
          });
        } else if (action[0].action === 'edit') {
          componentProcessList.map((element: any, index: any) => {
            if (componentProcessList.length == 1) {
              componentProcessList[index] = action[0].component[0];
            } else {
              const editedIngredient = action[0].component[0];
              const updatedItem = componentProcessList.filter(
                (data: any) => data.index == action[0].component[0].index
              );
              const indexItem = componentProcessList.indexOf(updatedItem[0]);
              componentProcessList[indexItem] = editedIngredient;
            }
          });
        } else if (action[0].action === 'delete') {
          const deletedIngredient = action[0].component;
          const deletedItem = componentProcessList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          componentProcessList.splice(componentProcessList.indexOf(deletedItem[0]), 1);
          componentProcessList = this.deleteCustomProcess(componentProcessList);
        }
        return of(
          ProjectsActions.eolPreRetailAddComponentSuccess({
            componentPreRetailList: componentProcessList,
            error: error,
          })
        );
      })
    )
  );

  preRetailReuseAction$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.preRetailReuseAction),
      withLatestFrom(this.store.pipe(select(ProjectsSelectors.getPreRetailReuseActionList))),
      exhaustMap(action => {
        let reuseDataList = Object.assign([], action[1]);
        if (action[0].action === 'add') {
          if (action[0].transport) {
            reuseDataList.push({ ...action[0].transport, index: reuseDataList.length + 1 });
          }
        }
        if (action[0].action === 'edit') {
          reuseDataList = this.addEnableEditing(reuseDataList);
          reuseDataList.forEach((element: any, index: any) => {
            const updatedItem = reuseDataList.filter(
              (data: any) => data.index == action[0].transport.index
            );
            const indx = reuseDataList.indexOf(updatedItem[0]);
            if (action[0].ingredientIndex == 'Amount') {
              reuseDataList[indx]['amount'] = action[0].transport.amount;
            } else if (action[0].ingredientIndex == 'CostperUnit') {
              reuseDataList[indx]['costperUnit'] = action[0].transport.costperUnit;
            } else if (action[0].ingredientIndex == 'CostperPackage') {
              reuseDataList[indx]['costperPackage'] = action[0].transport.costperPackage;
            } else if (action[0].ingredientIndex == 'processName') {
              reuseDataList[indx]['reuseFillingProcessName'] = action[0].transport.processName;
              reuseDataList[indx]['processName'] = action[0].transport.processName;
              if (action[0].transport?.isCustomReuse) {
                reuseDataList[indx]['customReuseId'] = action[0].transport.customReuseId;
              } else {
                reuseDataList[indx]['energyProcessId'] = action[0].transport.energyProcessId;
              }
            }
          });
        }
        if (action[0].action === 'delete') {
          const deletedIngredient = action[0].transport;
          const deletedItem = reuseDataList.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          reuseDataList.splice(reuseDataList.indexOf(deletedItem[0]), 1);
          reuseDataList = this.deleteCustomProcess(reuseDataList);
        }
        return of(
          ProjectsActions.preRetailReuseActionSuccess({
            preRetailReuseActionList: reuseDataList,
            dupliatePreRetailActionList: reuseDataList,
          })
        );
      })
    )
  );

  // add edit pre retail crud
  addEditEolPreRetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addEditEolPreRetail),
      exhaustMap(action => {
        if (action.pathName == 'preRetail') {
          return this.projectService
            .addEditEolPreRetail(action.preEolRetailPayload.mainPayload)
            .pipe(
              map((data: any) => {
                data['scenarioId'] = action.scenarioId;
                data['pathName'] = action.pathName;
                return ProjectsActions.addEditEolPreRetailSuccess({
                  preEolRetailData: data,
                });
              }),
              catchError((error: any) => of(ProjectsActions.addEditEolPreRetailFailure(error)))
            );
        } else {
          return this.projectService
            .addEditEolPostRetail(action.preEolRetailPayload.mainPayload)
            .pipe(
              map((data: any) => {
                data['scenarioId'] = action.scenarioId;
                data['pathName'] = action.preEolRetailPayload.pathName;
                return ProjectsActions.addEditEolPreRetailSuccess({
                  preEolRetailData: data,
                });
              }),
              catchError((error: any) => of(ProjectsActions.addEditEolPreRetailFailure(error)))
            );
        }
      })
    )
  );

  addEditEolPreRetailSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.addEditEolPreRetailSuccess),
      exhaustMap(action => {
        const toaster = action.preEolRetailData.messageType
          ? sharedAction.ToasterError({ description: action.preEolRetailData.message })
          : sharedAction.ToasterSuccess({ description: action.preEolRetailData.message });
        this.modal.close();
        if (action.preEolRetailData.pathName == 'preRetail') {
          this.getPreRetailData();
          return of(toaster, sharedAction.clearSearchFilter({ isClearSearch: true }));
        } else {
          this.getPostRetailData();
          return of(toaster, sharedAction.clearSearchFilter({ isClearSearch: true }));
        }
      })
    )
  );

  getProductMixList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.getProductMixList),
      exhaustMap(action => {
        const productList = action.payload?.productMixList.map((item: any, index: any) => {
          return {
            ...item,
            index: index + 1,
          };
        });
        return of(ProjectsActions.getProductMixListSuccess({ productMixProcess: productList }));
      })
    )
  );

  updateProductMixProcess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.updateProductMixProcess),
      withLatestFrom(this.store.pipe(select(ProjectsSelectors.productMixData))),
      exhaustMap((action: any) => {
        let error: any = '';
        let isExist;
        let updatedArr = Object.assign([], action[1]);
        isExist = updatedArr.length > 1 ? findDuplicates(updatedArr) : false;
        error =
          !!isExist && action[0].action != 'editInline'
            ? 'Product already exists, select different process to proceed further.'
            : '';
        if (action[0].action === 'add' && !isExist) {
          if (action[0].process) {
            updatedArr.push({ ...action[0].process, index: updatedArr.length + 1 });
          }
        }
        if (action[0].action === 'edit' || action[0].action == 'editInline') {
          updatedArr = this.addEnableEditing(updatedArr);
          updatedArr.forEach((element: any, index: any) => {
            if (updatedArr.length == 1) {
              updatedArr[index] = action[0].process;
            } else {
              const editedProduct = action[0].process;
              const updatedItem = updatedArr.filter(
                (data: any) => data.index == action[0].process.index
              );
              const index = updatedArr.indexOf(updatedItem[0]);
              updatedArr[index] = editedProduct;
            }
          });
        } else if (action[0].action === 'delete') {
          const deletedIngredient = action[0].process;
          const deletedItem = updatedArr.filter(
            (data: any) => data.index == deletedIngredient.index
          );
          updatedArr.splice(updatedArr.indexOf(deletedItem[0]), 1);
          updatedArr = this.deleteCustomProcess(updatedArr);
        }
        return of(
          ProjectsActions.updateProductMixProcessSuccess({
            productMixProcess: updatedArr,
            error: error,
          })
        );
      })
    )
  );

  deleteProductMixProcess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.deleteProductMixProcess),
      exhaustMap((action: any) => {
        return this.projectService.deleteProductPackageScenarioDetail(action.process?.id).pipe(
          map((data: any) => {
            !data.messageType
              ? this.toaster.success(data.message)
              : this.toaster.error(data.message);
            return ProjectsActions.deleteProductMixProcessSuccess();
          })
        );
      })
    )
  );

  recallSideBar() {
    this.sharedService.accessSideBarData(() => {});
  }

  openAddEditEolPreRetail(data: any, action: any) {
    this.modal.invoke('newEolPreRetail', {
      initialState: {
        newEolPreRetailData: data.data,
        locationProcessDef:
          this.projectPackEOLDataGridService.getTransportModalForManualLocationDataColumn(),
        distanceProcessColumnDef:
          this.projectPackEOLDataGridService.getTransportModalForManualDestinationDataColumn(),
        customTransportDef: this.projectPackEOLDataGridService.getCustomTransportItemsList(),
        ingredientTransportColumnDef:
          this.projectPackEOLDataGridService.newPreRetailTransportColumns(),
        columnDefsPreretailCost:
          this.projectPackEOLDataGridService.newPreRetailTransportColumnsCost(),
        reuseColumnDef: this.projectPackEOLDataGridService.reuseColumns(),
        label: action.actionLabel,
        pathName: action.pathName,
        reuseType: action?.reuseType,
      },
      class: 'modal-xl',
    });
    this.modal.ref?.content.saveNewPreRetailEvent.subscribe((saveNewPreRetailEvent: any) => {
      this.projectFacde.addEditEolPreRetail(
        saveNewPreRetailEvent,
        action.scenarioId,
        action.pathName
      );
    });
  }

  openPopupRetailAndConsumer(data: any, action: any) {
    this.modal.invoke('newAddProjectScenarioRetail', {
      initialState: {
        newMyProjectsPackRetail: data.data,
        label: action.actionLabel,
        pathName: action.pathName,
        customTransportColumnDef:
          this.projectScenarioRetailDataGridService.getCustomTransportItemsList(),
        customEolDef: this.projectScenarioRetailDataGridService.getendOfLifeDataColumn(),
      },
      class: 'modal-xl',
    });
    this.modal.ref?.content.saveNewMyProjectPackRetailEvent.subscribe(
      (saveNewMyProjectPackRetailEvent: any) => {
        return of(
          this.projectFacde.addEditMyProjectPackRetail(
            saveNewMyProjectPackRetailEvent,
            action.pathName,
            action.scenarioId
          )
        );
      }
    );
  }

  deleteCustomProcess(type: any) {
    return type.map((item: any, i: any) => {
      return {
        ...item,
        index: item.id == 0 || !item.hasOwnProperty('ingredientId') ? i + 1 : item.ingredientId,
      };
    });
  }

  async alertConfirmation(action: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.projectFacde.deleteProjectData(
          action?.action?.productId || action?.action?.projectId || action.id,
          action.pathName,
          action.projectId,
          action.scenarioTypeId,
          action.pageName
        );
      }
    });
  }

  inlineDataEditScenarioConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.inlineDataEditForScenarioConfig),
      exhaustMap(action => {
        return this.projectService
          .projectRetailAndConsumerInlineEdit(action.scenarioConfigPayload)
          .pipe(
            map((data: any) => {
              data = { ...data, type: action.scenarioConfigPayload };
              data['pathName'] = action.pathName;
              return ProjectsActions.inlineDataEditForScenarioConfigSuccess({
                scenarioConfigInlineData: data,
              });
            }),
            catchError((error: any) =>
              of(ProjectsActions.inlineDataEditForScenarioConfigFailure(error))
            )
          );
      })
    )
  );

  storeProjectName$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.projectNameForBreadCrumbs),
      exhaustMap(action => {
        return of(
          ProjectsActions.projectNameForBreadCrumbsSuccess({
            projectName: action.projectName,
          })
        );
      })
    )
  );

  getRetailListData() {
    this.projectScenarioRetailDataGridService.getRetailList();
  }

  reMapDistanceData(data: any) {
    return (data.data.distanceTransportationItems = data.data.distanceTransportationItems.map(
      (item: any, index: any) => {
        return {
          ...item,
          index: item.idLong,
        };
      }
    ));
  }

  addEnableEditing(list: any) {
    return (list = list.map((x: any) => {
      return {
        ...x,
        enableEditing: false,
      };
    }));
  }

  getScenarioId() {
    this.route.queryParams.subscribe((data: any) => {
      let value: any = decrypt(data.param ? data.param : '');
      value = value && !value.includes('undefined') ? JSON.parse(value) : '';
      this.scenarioId = value['id'];
      this.packageScenarioId = value['packageScenarioId'];
    });
    return { scenarioId: this.scenarioId, packageScenarioId: this.packageScenarioId };
  }

  openImportNewAddProjectMaterialModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.openImportNewAddProjectMaterialModal),
      exhaustMap((action: any) =>
        this.projectService.getAddEditPackMaterialModal(0, 0, action.isMaterial).pipe(
          map((data: any) => {
            if (
              ['Review component details', 'Review material & conversion details'].includes(
                action.actionLabel
              )
            ) {
              [
                'conversionProcessItems',
                'distanceTransportationItems',
                'locationTransportationItems',
              ].forEach(key => {
                data.data[key] = data.data[key].map((item: any) => ({
                  ...item,
                  index: item.id,
                  distance:
                    key === 'locationTransportationItems' && !item.isOrigin
                      ? this.setUnit(item)
                      : item.distance || '',
                }));
              });
            }

            const defaultKeys = [
              'name',
              'scenarioId',
              'packageLevelId',
              'recylcableComponent',
              'isCustomMaterial',
              'recycledContent',
              'carbonNeutral',
              'fscCertification',
              'otherCertification',
              'conversionProcessItems',
              'distanceTransportationItems',
              'locationTransportationItems',
              'customTransoportScenarioDetailViewModels',
              'isRecommendedConversionProcess',
              'isAreaBaseConversionProcess',
              'isCustomConversion',
              'componentId',
              'countryName',
              'transportaionId',
              'materialCost',
              'materialCountryId',
              'conversionCountryId',
              'materialId',
              'materialSupplierId',
              'materialSupplierName',
              'materialWeight',
              'conversionPlaceName',
              'customtransportScenarioId',
            ];
            defaultKeys.forEach(key => {
              data.data[key] = action.data[key] || data.data[key];
            });

            data.data.materialRegion = [...this.importProjectService.getCountryList()];
            data.data.conversionRegion = [...this.importProjectService.getCountryList()];
            data.data.packagingLevels =
              this.importProjectService
                .getPackagingLevelDetailInfo()
                .find(
                  (scenario: PackagingLevelDetailScenario) =>
                    scenario.scenarioId === action.scenarioId
                )
                ?.packagingLevelDetail?.map((item: PackagingLevelDetail) => ({
                  ...item,
                  packagingLevelId: item.packagingLevelId || 0,
                })) || [];

            this.modal.invoke('importNewProjectMaterial', {
              initialState: {
                newMyProjectsPackMaterial: data.data,
                label: action.actionLabel,
                customTransportColumnDef:
                  this.projectPackMaterialDataGridService.getCustomTransportItemsList(),
              },
              class: 'modal-xl',
            });

            this.modal.ref?.content.saveNewMyProjectPackMaterialEvent.subscribe((event: any) => {
              const projectData = this.importProjectService.getProjectInfo();
              const scenario = projectData?.ScenarioList?.find(
                (s: any) => s.scenarioId === action.scenarioId
              );

              if (scenario && scenario.materialList) {
                const materialIndex = scenario.materialList.findIndex(
                  (m: any) => m.componentId === action.data.componentId
                );

                if (materialIndex > -1) {
                  const material = scenario.materialList[materialIndex];
                  Object.keys(event).forEach(key => {
                    if (material.hasOwnProperty(key)) {
                      material[key] = event[key];
                    }
                  });
                } else {
                  console.warn(`No material found with componentId: ${action.data.componentId}`);
                }
              } else {
                console.warn(
                  `Scenario or materialList not found for scenarioId: ${action.scenarioId}`
                );
              }

              this.importProjectService.updateProjectImportInfo(projectData);
            });
            return ProjectsActions.openNewAddProjectMaterialModalSuccess({
              openNewAddProjectMaterialModalData: data,
            });
          })
        )
      )
    )
  );

  constructor(
    private projectService: ProjectsService,
    private sharedFacade: SharedFacade,
    private sharedService: SharedService,
    private projectFacde: ProjectsFacade,
    private projectsDataGridService: ProjectsDataGridService,
    private projectScenarioRetailDataGridService: ProjectScenarioRetailDataGridService,
    private modal: CustomModalService,
    private store: Store,
    private projectScenarioDataGridService: ProjectScenarioDataGridService,
    private projectPackMaterialDataGridService: ProjectPackMaterialListDataGridService,
    private router: Router,
    private projectScenarioWholesaleDataGridService: ProjectScenarioWholesaleDataGridService,
    private productIngredientDataGridService: ProductIngredientDataGridService,
    private projectPackConversionDataGridService: ProjectPackConversionDataGridService,
    private projectScenarioFillingDataGridService: ProjectScenarioFillingDataGridService,
    private projectScenarioConsumerDataGridService: ProjectScenarioConsumerDataGridService,
    private productManufactureDataGridService: ProductManufactureDataGridService,
    private projectPackEOLDataGridService: ProjectPackEOLDataGridService,
    private swalService: SwalService,
    private myOrganizationService: MyOrganizationService,
    public route: ActivatedRoute,
    private toaster: ToastrService,
    private importProjectService: ImportDataService
  ) {
    this.url = location.href.split('/');
    this.projectId = this.url[6];
  }
}
/* eslint-enable @typescript-eslint/no-explicit-any */
